/*!
 * @license Firebase v4.6.2
 * Build: rev-cbb07d3
 * Terms: https://firebase.google.com/terms/
 */
var firebase = (function() {
 var window = typeof window === 'undefined' ? self : window;
 return /******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonpFirebase"];
/******/ 	window["webpackJsonpFirebase"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		5: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 57);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function __export(m) {
 for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(28));
__export(__webpack_require__(29));
__export(__webpack_require__(20));
__export(__webpack_require__(65));
__export(__webpack_require__(66));
__export(__webpack_require__(67));
__export(__webpack_require__(68));
__export(__webpack_require__(30));
__export(__webpack_require__(69));
__export(__webpack_require__(31));
__export(__webpack_require__(70));
__export(__webpack_require__(71));
__export(__webpack_require__(73));
__export(__webpack_require__(74));
__export(__webpack_require__(75));

//# sourceMappingURL=index.js.map


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../util/dist/cjs/index.js
var cjs = __webpack_require__(0);
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);

// CONCATENATED MODULE: ../app/dist/esm/src/firebaseApp.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var contains = function (obj, key) {
 return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var firebaseApp_FirebaseAppImpl = /** @class */ (function () {
 function FirebaseAppImpl(options, name, firebase_) {
 this.firebase_ = firebase_;
 this.isDeleted_ = false;
 this.services_ = {};
 this.name_ = name;
 this.options_ = Object(cjs["deepCopy"])(options);
 this.INTERNAL = {
 getUid: function () { return null; },
 getToken: function () { return Promise.resolve(null); },
 addAuthTokenListener: function (callback) {
 tokenListeners.push(callback);
 // Make sure callback is called, asynchronously, in the absence of the auth module
 setTimeout(function () { return callback(null); }, 0);
 },
 removeAuthTokenListener: function (callback) {
 tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
 }
 };
 }
 Object.defineProperty(FirebaseAppImpl.prototype, "name", {
 get: function () {
 this.checkDestroyed_();
 return this.name_;
 },
 enumerable: true,
 configurable: true
 });
 Object.defineProperty(FirebaseAppImpl.prototype, "options", {
 get: function () {
 this.checkDestroyed_();
 return this.options_;
 },
 enumerable: true,
 configurable: true
 });
 FirebaseAppImpl.prototype.delete = function () {
 var _this = this;
 return new Promise(function (resolve) {
 _this.checkDestroyed_();
 resolve();
 })
 .then(function () {
 _this.firebase_.INTERNAL.removeApp(_this.name_);
 var services = [];
 Object.keys(_this.services_).forEach(function (serviceKey) {
 Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
 services.push(_this.services_[serviceKey][instanceKey]);
 });
 });
 return Promise.all(services.map(function (service) {
 return service.INTERNAL.delete();
 }));
 })
 .then(function () {
 _this.isDeleted_ = true;
 _this.services_ = {};
 });
 };
 /**
 * Return a service instance associated with this app (creating it
 * on demand), identified by the passed instanceIdentifier.
 *
 * NOTE: Currently storage is the only one that is leveraging this
 * functionality. They invoke it by calling:
 *
 * ```javascript
 * firebase.app().storage('STORAGE BUCKET ID')
 * ```
 *
 * The service name is passed to this already
 * @internal
 */
 FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
 if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
 this.checkDestroyed_();
 if (!this.services_[name]) {
 this.services_[name] = {};
 }
 if (!this.services_[name][instanceIdentifier]) {
 /**
 * If a custom instance has been defined (i.e. not '[DEFAULT]')
 * then we will pass that instance on, otherwise we pass `null`
 */
 var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
 ? instanceIdentifier
 : undefined;
 var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
 this.services_[name][instanceIdentifier] = service;
 }
 return this.services_[name][instanceIdentifier];
 };
 /**
 * Callback function used to extend an App instance at the time
 * of service instance creation.
 */
 FirebaseAppImpl.prototype.extendApp = function (props) {
 var _this = this;
 // Copy the object onto the FirebaseAppImpl prototype
 Object(cjs["deepExtend"])(this, props);
 /**
 * If the app has overwritten the addAuthTokenListener stub, forward
 * the active token listeners on to the true fxn.
 *
 * TODO: This function is required due to our current module
 * structure. Once we are able to rely strictly upon a single module
 * implementation, this code should be refactored and Auth should
 * provide these stubs and the upgrade logic
 */
 if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
 tokenListeners.forEach(function (listener) {
 _this.INTERNAL.addAuthTokenListener(listener);
 });
 tokenListeners = [];
 }
 };
 /**
 * This function will throw an Error if the App has already been deleted -
 * use before performing API actions on the App.
 */
 FirebaseAppImpl.prototype.checkDestroyed_ = function () {
 if (this.isDeleted_) {
 error('app-deleted', { name: this.name_ });
 }
 };
 return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(firebaseApp_FirebaseAppImpl.prototype.name && firebaseApp_FirebaseAppImpl.prototype.options) ||
 firebaseApp_FirebaseAppImpl.prototype.delete ||
 console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global. It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
 var apps_ = {};
 var factories = {};
 var appHooks = {};
 // A namespace is a plain JavaScript Object.
 var namespace = {
 // Hack to prevent Babel from modifying the object returned
 // as the firebase namespace.
 __esModule: true,
 initializeApp: initializeApp,
 app: app,
 apps: null,
 Promise: Promise,
 SDK_VERSION: '4.6.1',
 INTERNAL: {
 registerService: registerService,
 createFirebaseNamespace: createFirebaseNamespace,
 extendNamespace: extendNamespace,
 createSubscribe: cjs["createSubscribe"],
 ErrorFactory: cjs["ErrorFactory"],
 removeApp: removeApp,
 factories: factories,
 useAsService: useAsService,
 Promise: Promise,
 deepExtend: cjs["deepExtend"]
 }
 };
 // Inject a circular default export to allow Babel users who were previously
 // using:
 //
 // import firebase from 'firebase';
 // which becomes: var firebase = require('firebase').default;
 //
 // instead of
 //
 // import * as firebase from 'firebase';
 // which becomes: var firebase = require('firebase');
 Object(cjs["patchProperty"])(namespace, 'default', namespace);
 // firebase.apps is a read-only getter.
 Object.defineProperty(namespace, 'apps', {
 get: getApps
 });
 /**
 * Called by App.delete() - but before any services associated with the App
 * are deleted.
 */
 function removeApp(name) {
 var app = apps_[name];
 callAppHooks(app, 'delete');
 delete apps_[name];
 }
 /**
 * Get the App object for a given name (or DEFAULT).
 */
 function app(name) {
 name = name || DEFAULT_ENTRY_NAME;
 if (!contains(apps_, name)) {
 error('no-app', { name: name });
 }
 return apps_[name];
 }
 Object(cjs["patchProperty"])(app, 'App', firebaseApp_FirebaseAppImpl);
 /**
 * Create a new App instance (name must be unique).
 */
 function initializeApp(options, name) {
 if (name === undefined) {
 name = DEFAULT_ENTRY_NAME;
 }
 else {
 if (typeof name !== 'string' || name === '') {
 error('bad-app-name', { name: name + '' });
 }
 }
 if (contains(apps_, name)) {
 error('duplicate-app', { name: name });
 }
 var app = new firebaseApp_FirebaseAppImpl(options, name, namespace);
 apps_[name] = app;
 callAppHooks(app, 'create');
 return app;
 }
 /*
 * Return an array of all the non-deleted FirebaseApps.
 */
 function getApps() {
 // Make a copy so caller cannot mutate the apps list.
 return Object.keys(apps_).map(function (name) { return apps_[name]; });
 }
 /*
 * Register a Firebase Service.
 *
 * firebase.INTERNAL.registerService()
 *
 * TODO: Implement serviceProperties.
 */
 function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
 // Cannot re-register a service that already exists
 if (factories[name]) {
 error('duplicate-service', { name: name });
 }
 // Capture the service factory for later service instantiation
 factories[name] = createService;
 // Capture the appHook, if passed
 if (appHook) {
 appHooks[name] = appHook;
 // Run the **new** app hook on all existing apps
 getApps().forEach(function (app) {
 appHook('create', app);
 });
 }
 // The Service namespace is an accessor function ...
 var serviceNamespace = function (appArg) {
 if (appArg === void 0) { appArg = app(); }
 if (typeof appArg[name] !== 'function') {
 // Invalid argument.
 // This happens in the following case: firebase.storage('gs:/')
 error('invalid-app-argument', { name: name });
 }
 // Forward service instance lookup to the FirebaseApp.
 return appArg[name]();
 };
 // ... and a container for service-level properties.
 if (serviceProperties !== undefined) {
 Object(cjs["deepExtend"])(serviceNamespace, serviceProperties);
 }
 // Monkey-patch the serviceNamespace onto the firebase namespace
 namespace[name] = serviceNamespace;
 // Patch the FirebaseAppImpl prototype
 firebaseApp_FirebaseAppImpl.prototype[name] = function () {
 var args = [];
 for (var _i = 0; _i < arguments.length; _i++) {
 args[_i] = arguments[_i];
 }
 var serviceFxn = this._getService.bind(this, name);
 return serviceFxn.apply(this, allowMultipleInstances ? args : []);
 };
 return serviceNamespace;
 }
 /**
 * Patch the top-level firebase namespace with additional properties.
 *
 * firebase.INTERNAL.extendNamespace()
 */
 function extendNamespace(props) {
 Object(cjs["deepExtend"])(namespace, props);
 }
 function callAppHooks(app, eventName) {
 Object.keys(factories).forEach(function (serviceName) {
 // Ignore virtual services
 var factoryName = useAsService(app, serviceName);
 if (factoryName === null) {
 return;
 }
 if (appHooks[factoryName]) {
 appHooks[factoryName](eventName, app);
 }
 });
 }
 // Map the requested service to a registered service name
 // (used to map auth to serverAuth service when needed).
 function useAsService(app, name) {
 if (name === 'serverAuth') {
 return null;
 }
 var useService = name;
 var options = app.options;
 return useService;
 }
 return namespace;
}
function error(code, args) {
 throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
 'no-app': "No Firebase App '{$name}' has been created - " +
 'call Firebase App.initializeApp()',
 'bad-app-name': "Illegal App name: '{$name}",
 'duplicate-app': "Firebase App named '{$name}' already exists",
 'app-deleted': "Firebase App named '{$name}' already deleted",
 'duplicate-service': "Firebase service named '{$name}' already registered",
 'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
 'account is only allowed in a Node.js environment. On client ' +
 'devices, you should instead initialize the SDK with an api key and ' +
 'auth domain',
 'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
 'Firebase App instance.'
};
var appErrors = new cjs["ErrorFactory"]('app', 'Firebase', errors);


//# sourceMappingURL=firebaseApp.js.map

// CONCATENATED MODULE: ../app/dist/esm/index.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firebase", function() { return firebase; });
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var firebase = createFirebaseNamespace();
/* harmony default export */ var esm = __webpack_exports__["default"] = (firebase);


//# sourceMappingURL=index.js.map


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @fileoverview Firebase constants. Some of these (@defines) can be overridden at compile-time.
 */
exports.CONSTANTS = {
 /**
 * @define {boolean} Whether this is the client Node.js SDK.
 */
 NODE_CLIENT: false,
 /**
 * @define {boolean} Whether this is the Admin Node.js SDK.
 */
 NODE_ADMIN: false,
 /**
 * Firebase SDK Version
 */
 SDK_VERSION: '${JSCORE_VERSION}'
};

//# sourceMappingURL=constants.js.map


/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things. But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals. It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
 throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
 throw new Error('clearTimeout has not been defined');
}
(function () {
 try {
 if (typeof setTimeout === 'function') {
 cachedSetTimeout = setTimeout;
 } else {
 cachedSetTimeout = defaultSetTimout;
 }
 } catch (e) {
 cachedSetTimeout = defaultSetTimout;
 }
 try {
 if (typeof clearTimeout === 'function') {
 cachedClearTimeout = clearTimeout;
 } else {
 cachedClearTimeout = defaultClearTimeout;
 }
 } catch (e) {
 cachedClearTimeout = defaultClearTimeout;
 }
} ())
function runTimeout(fun) {
 if (cachedSetTimeout === setTimeout) {
 //normal enviroments in sane situations
 return setTimeout(fun, 0);
 }
 // if setTimeout wasn't available but was latter defined
 if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
 cachedSetTimeout = setTimeout;
 return setTimeout(fun, 0);
 }
 try {
 // when when somebody has screwed with setTimeout but no I.E. maddness
 return cachedSetTimeout(fun, 0);
 } catch(e){
 try {
 // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
 return cachedSetTimeout.call(null, fun, 0);
 } catch(e){
 // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
 return cachedSetTimeout.call(this, fun, 0);
 }
 }


}
function runClearTimeout(marker) {
 if (cachedClearTimeout === clearTimeout) {
 //normal enviroments in sane situations
 return clearTimeout(marker);
 }
 // if clearTimeout wasn't available but was latter defined
 if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
 cachedClearTimeout = clearTimeout;
 return clearTimeout(marker);
 }
 try {
 // when when somebody has screwed with setTimeout but no I.E. maddness
 return cachedClearTimeout(marker);
 } catch (e){
 try {
 // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
 return cachedClearTimeout.call(null, marker);
 } catch (e){
 // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
 // Some versions of I.E. have different rules for clearTimeout vs setTimeout
 return cachedClearTimeout.call(this, marker);
 }
 }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
 if (!draining || !currentQueue) {
 return;
 }
 draining = false;
 if (currentQueue.length) {
 queue = currentQueue.concat(queue);
 } else {
 queueIndex = -1;
 }
 if (queue.length) {
 drainQueue();
 }
}

function drainQueue() {
 if (draining) {
 return;
 }
 var timeout = runTimeout(cleanUpNextTick);
 draining = true;

 var len = queue.length;
 while(len) {
 currentQueue = queue;
 queue = [];
 while (++queueIndex < len) {
 if (currentQueue) {
 currentQueue[queueIndex].run();
 }
 }
 queueIndex = -1;
 len = queue.length;
 }
 currentQueue = null;
 draining = false;
 runClearTimeout(timeout);
}

process.nextTick = function (fun) {
 var args = new Array(arguments.length - 1);
 if (arguments.length > 1) {
 for (var i = 1; i < arguments.length; i++) {
 args[i - 1] = arguments[i];
 }
 }
 queue.push(new Item(fun, args));
 if (queue.length === 1 && !draining) {
 runTimeout(drainQueue);
 }
};

// v8 likes predictible objects
function Item(fun, array) {
 this.fun = fun;
 this.array = array;
}
Item.prototype.run = function () {
 this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
 throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
 throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(20);
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
exports.assert = function (assertion, message) {
 if (!assertion) {
 throw exports.assertionError(message);
 }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
exports.assertionError = function (message) {
 return new Error('Firebase Database (' +
 constants_1.CONSTANTS.SDK_VERSION +
 ') INTERNAL ASSERT FAILED: ' +
 message);
};

//# sourceMappingURL=assert.js.map


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var stringToByteArray = function (str) {
 var output = [], p = 0;
 for (var i = 0; i < str.length; i++) {
 var c = str.charCodeAt(i);
 while (c > 255) {
 output[p++] = c & 255;
 c >>= 8;
 }
 output[p++] = c;
 }
 return output;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
 var CHUNK_SIZE = 8192;
 // Special-case the simple case for speed's sake.
 if (bytes.length < CHUNK_SIZE) {
 return String.fromCharCode.apply(null, bytes);
 }
 // The remaining logic splits conversion by chunks since
 // Function#apply() has a maximum parameter count.
 // See discussion: http://goo.gl/LrWmZ9
 var str = '';
 for (var i = 0; i < bytes.length; i += CHUNK_SIZE) {
 var chunk = bytes.slice(i, i + CHUNK_SIZE);
 str += String.fromCharCode.apply(null, chunk);
 }
 return str;
};
// Static lookup maps, lazily populated by init_()
exports.base64 = {
 /**
 * Maps bytes to characters.
 * @type {Object}
 * @private
 */
 byteToCharMap_: null,
 /**
 * Maps characters to bytes.
 * @type {Object}
 * @private
 */
 charToByteMap_: null,
 /**
 * Maps bytes to websafe characters.
 * @type {Object}
 * @private
 */
 byteToCharMapWebSafe_: null,
 /**
 * Maps websafe characters to bytes.
 * @type {Object}
 * @private
 */
 charToByteMapWebSafe_: null,
 /**
 * Our default alphabet, shared between
 * ENCODED_VALS and ENCODED_VALS_WEBSAFE
 * @type {string}
 */
 ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
 /**
 * Our default alphabet. Value 64 (=) is special; it means "nothing."
 * @type {string}
 */
 get ENCODED_VALS() {
 return this.ENCODED_VALS_BASE + '+/=';
 },
 /**
 * Our websafe alphabet.
 * @type {string}
 */
 get ENCODED_VALS_WEBSAFE() {
 return this.ENCODED_VALS_BASE + '-_.';
 },
 /**
 * Whether this browser supports the atob and btoa functions. This extension
 * started at Mozilla but is now implemented by many browsers. We use the
 * ASSUME_* variables to avoid pulling in the full useragent detection library
 * but still allowing the standard per-browser compilations.
 *
 * @type {boolean}
 */
 HAS_NATIVE_SUPPORT: typeof atob === 'function',
 /**
 * Base64-encode an array of bytes.
 *
 * @param {Array|Uint8Array} input An array of bytes (numbers with
 * value in [0, 255]) to encode.
 * @param {boolean=} opt_webSafe Boolean indicating we should use the
 * alternative alphabet.
 * @return {string} The base64 encoded string.
 */
 encodeByteArray: function (input, opt_webSafe) {
 if (!Array.isArray(input)) {
 throw Error('encodeByteArray takes an array as a parameter');
 }
 this.init_();
 var byteToCharMap = opt_webSafe
 ? this.byteToCharMapWebSafe_
 : this.byteToCharMap_;
 var output = [];
 for (var i = 0; i < input.length; i += 3) {
 var byte1 = input[i];
 var haveByte2 = i + 1 < input.length;
 var byte2 = haveByte2 ? input[i + 1] : 0;
 var haveByte3 = i + 2 < input.length;
 var byte3 = haveByte3 ? input[i + 2] : 0;
 var outByte1 = byte1 >> 2;
 var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
 var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
 var outByte4 = byte3 & 0x3f;
 if (!haveByte3) {
 outByte4 = 64;
 if (!haveByte2) {
 outByte3 = 64;
 }
 }
 output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
 }
 return output.join('');
 },
 /**
 * Base64-encode a string.
 *
 * @param {string} input A string to encode.
 * @param {boolean=} opt_webSafe If true, we should use the
 * alternative alphabet.
 * @return {string} The base64 encoded string.
 */
 encodeString: function (input, opt_webSafe) {
 // Shortcut for Mozilla browsers that implement
 // a native base64 encoder in the form of "btoa/atob"
 if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
 return btoa(input);
 }
 return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
 },
 /**
 * Base64-decode a string.
 *
 * @param {string} input to decode.
 * @param {boolean=} opt_webSafe True if we should use the
 * alternative alphabet.
 * @return {string} string representing the decoded value.
 */
 decodeString: function (input, opt_webSafe) {
 // Shortcut for Mozilla browsers that implement
 // a native base64 encoder in the form of "btoa/atob"
 if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
 return atob(input);
 }
 return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
 },
 /**
 * Base64-decode a string.
 *
 * In base-64 decoding, groups of four characters are converted into three
 * bytes. If the encoder did not apply padding, the input length may not
 * be a multiple of 4.
 *
 * In this case, the last group will have fewer than 4 characters, and
 * padding will be inferred. If the group has one or two characters, it decodes
 * to one byte. If the group has three characters, it decodes to two bytes.
 *
 * @param {string} input Input to decode.
 * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
 * @return {!Array} bytes representing the decoded value.
 */
 decodeStringToByteArray: function (input, opt_webSafe) {
 this.init_();
 var charToByteMap = opt_webSafe
 ? this.charToByteMapWebSafe_
 : this.charToByteMap_;
 var output = [];
 for (var i = 0; i < input.length;) {
 var byte1 = charToByteMap[input.charAt(i++)];
 var haveByte2 = i < input.length;
 var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
 ++i;
 var haveByte3 = i < input.length;
 var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
 ++i;
 var haveByte4 = i < input.length;
 var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
 ++i;
 if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
 throw Error();
 }
 var outByte1 = (byte1 << 2) | (byte2 >> 4);
 output.push(outByte1);
 if (byte3 != 64) {
 var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
 output.push(outByte2);
 if (byte4 != 64) {
 var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
 output.push(outByte3);
 }
 }
 }
 return output;
 },
 /**
 * Lazy static initialization function. Called before
 * accessing any of the static map variables.
 * @private
 */
 init_: function () {
 if (!this.byteToCharMap_) {
 this.byteToCharMap_ = {};
 this.charToByteMap_ = {};
 this.byteToCharMapWebSafe_ = {};
 this.charToByteMapWebSafe_ = {};
 // We want quick mappings back and forth, so we precompute two maps.
 for (var i = 0; i < this.ENCODED_VALS.length; i++) {
 this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
 this.charToByteMap_[this.byteToCharMap_[i]] = i;
 this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
 this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
 // Be forgiving when decoding and correctly decode both encodings.
 if (i >= this.ENCODED_VALS_BASE.length) {
 this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
 this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
 }
 }
 }
 }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
exports.base64Encode = function (str) {
 var utf8Bytes = stringToByteArray(str);
 return exports.base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
exports.base64Decode = function (str) {
 try {
 return exports.base64.decodeString(str, true);
 }
 catch (e) {
 console.error('base64Decode failed: ', e);
 }
 return null;
};

//# sourceMappingURL=crypt.js.map


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
 return JSON.parse(str);
}
exports.jsonEval = jsonEval;
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
 return JSON.stringify(data);
}
exports.stringify = stringify;

//# sourceMappingURL=json.js.map


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
exports.contains = function (obj, key) {
 return Object.prototype.hasOwnProperty.call(obj, key);
};
exports.safeGet = function (obj, key) {
 if (Object.prototype.hasOwnProperty.call(obj, key))
 return obj[key];
 // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
exports.forEach = function (obj, fn) {
 for (var key in obj) {
 if (Object.prototype.hasOwnProperty.call(obj, key)) {
 fn(key, obj[key]);
 }
 }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
exports.extend = function (objTo, objFrom) {
 exports.forEach(objFrom, function (key, value) {
 objTo[key] = value;
 });
 return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
exports.clone = function (obj) {
 return exports.extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null. Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
exports.isNonNullObject = function (obj) {
 return typeof obj === 'object' && obj !== null;
};
exports.isEmpty = function (obj) {
 for (var key in obj) {
 return false;
 }
 return true;
};
exports.getCount = function (obj) {
 var rv = 0;
 for (var key in obj) {
 rv++;
 }
 return rv;
};
exports.map = function (obj, f, opt_obj) {
 var res = {};
 for (var key in obj) {
 res[key] = f.call(opt_obj, obj[key], key, obj);
 }
 return res;
};
exports.findKey = function (obj, fn, opt_this) {
 for (var key in obj) {
 if (fn.call(opt_this, obj[key], key, obj)) {
 return key;
 }
 }
 return undefined;
};
exports.findValue = function (obj, fn, opt_this) {
 var key = exports.findKey(obj, fn, opt_this);
 return key && obj[key];
};
exports.getAnyKey = function (obj) {
 for (var key in obj) {
 return key;
 }
};
exports.getValues = function (obj) {
 var res = [];
 var i = 0;
 for (var key in obj) {
 res[i++] = obj[key];
 }
 return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
exports.every = function (obj, fn) {
 for (var key in obj) {
 if (Object.prototype.hasOwnProperty.call(obj, key)) {
 if (!fn(key, obj[key])) {
 return false;
 }
 }
 }
 return true;
};

//# sourceMappingURL=obj.js.map


/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(58);
module.exports = __webpack_require__(6).default;


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_shims_find__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_shims_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_shims_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex__);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




//# sourceMappingURL=index.js.map


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __global = (function () {
 if (typeof global !== 'undefined') {
 return global;
 }
 if (typeof window !== 'undefined') {
 return window;
 }
 if (typeof self !== 'undefined') {
 return self;
 }
 throw new Error('unable to locate global object');
})();
// Polyfill Promise
if (typeof Promise === 'undefined') {
 // HACK: TS throws an error if I attempt to use 'dot-notation'
 __global['Promise'] = Promise = __webpack_require__(60);
}

//# sourceMappingURL=promise.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(19)))

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

 // Store setTimeout reference so promise-polyfill will be unaffected by
 // other code modifying setTimeout (like sinon.useFakeTimers())
 var setTimeoutFunc = setTimeout;

 function noop() {}
 
 // Polyfill for Function.prototype.bind
 function bind(fn, thisArg) {
 return function () {
 fn.apply(thisArg, arguments);
 };
 }

 function Promise(fn) {
 if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
 if (typeof fn !== 'function') throw new TypeError('not a function');
 this._state = 0;
 this._handled = false;
 this._value = undefined;
 this._deferreds = [];

 doResolve(fn, this);
 }

 function handle(self, deferred) {
 while (self._state === 3) {
 self = self._value;
 }
 if (self._state === 0) {
 self._deferreds.push(deferred);
 return;
 }
 self._handled = true;
 Promise._immediateFn(function () {
 var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
 if (cb === null) {
 (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
 return;
 }
 var ret;
 try {
 ret = cb(self._value);
 } catch (e) {
 reject(deferred.promise, e);
 return;
 }
 resolve(deferred.promise, ret);
 });
 }

 function resolve(self, newValue) {
 try {
 // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
 if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
 if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
 var then = newValue.then;
 if (newValue instanceof Promise) {
 self._state = 3;
 self._value = newValue;
 finale(self);
 return;
 } else if (typeof then === 'function') {
 doResolve(bind(then, newValue), self);
 return;
 }
 }
 self._state = 1;
 self._value = newValue;
 finale(self);
 } catch (e) {
 reject(self, e);
 }
 }

 function reject(self, newValue) {
 self._state = 2;
 self._value = newValue;
 finale(self);
 }

 function finale(self) {
 if (self._state === 2 && self._deferreds.length === 0) {
 Promise._immediateFn(function() {
 if (!self._handled) {
 Promise._unhandledRejectionFn(self._value);
 }
 });
 }

 for (var i = 0, len = self._deferreds.length; i < len; i++) {
 handle(self, self._deferreds[i]);
 }
 self._deferreds = null;
 }

 function Handler(onFulfilled, onRejected, promise) {
 this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
 this.onRejected = typeof onRejected === 'function' ? onRejected : null;
 this.promise = promise;
 }

 /**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
 function doResolve(fn, self) {
 var done = false;
 try {
 fn(function (value) {
 if (done) return;
 done = true;
 resolve(self, value);
 }, function (reason) {
 if (done) return;
 done = true;
 reject(self, reason);
 });
 } catch (ex) {
 if (done) return;
 done = true;
 reject(self, ex);
 }
 }

 Promise.prototype['catch'] = function (onRejected) {
 return this.then(null, onRejected);
 };

 Promise.prototype.then = function (onFulfilled, onRejected) {
 var prom = new (this.constructor)(noop);

 handle(this, new Handler(onFulfilled, onRejected, prom));
 return prom;
 };

 Promise.all = function (arr) {
 var args = Array.prototype.slice.call(arr);

 return new Promise(function (resolve, reject) {
 if (args.length === 0) return resolve([]);
 var remaining = args.length;

 function res(i, val) {
 try {
 if (val && (typeof val === 'object' || typeof val === 'function')) {
 var then = val.then;
 if (typeof then === 'function') {
 then.call(val, function (val) {
 res(i, val);
 }, reject);
 return;
 }
 }
 args[i] = val;
 if (--remaining === 0) {
 resolve(args);
 }
 } catch (ex) {
 reject(ex);
 }
 }

 for (var i = 0; i < args.length; i++) {
 res(i, args[i]);
 }
 });
 };

 Promise.resolve = function (value) {
 if (value && typeof value === 'object' && value.constructor === Promise) {
 return value;
 }

 return new Promise(function (resolve) {
 resolve(value);
 });
 };

 Promise.reject = function (value) {
 return new Promise(function (resolve, reject) {
 reject(value);
 });
 };

 Promise.race = function (values) {
 return new Promise(function (resolve, reject) {
 for (var i = 0, len = values.length; i < len; i++) {
 values[i].then(resolve, reject);
 }
 });
 };

 // Use polyfill for setImmediate for performance gains
 Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
 function (fn) {
 setTimeoutFunc(fn, 0);
 };

 Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
 if (typeof console !== 'undefined' && console) {
 console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
 }
 };

 /**
 * Set the immediate function to execute callbacks
 * @param fn {function} Function to execute
 * @deprecated
 */
 Promise._setImmediateFn = function _setImmediateFn(fn) {
 Promise._immediateFn = fn;
 };

 /**
 * Change the function to execute on unhandled rejection
 * @param {function} fn Function to execute on unhandled rejection
 * @deprecated
 */
 Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
 Promise._unhandledRejectionFn = fn;
 };
 
 if (typeof module !== 'undefined' && module.exports) {
 module.exports = Promise;
 } else if (!root.Promise) {
 root.Promise = Promise;
 }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(61).setImmediate))

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
 return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
 return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
 if (timeout) {
 timeout.close();
 }
};

function Timeout(id, clearFn) {
 this._id = id;
 this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
 this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
 clearTimeout(item._idleTimeoutId);
 item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
 clearTimeout(item._idleTimeoutId);
 item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
 clearTimeout(item._idleTimeoutId);

 var msecs = item._idleTimeout;
 if (msecs >= 0) {
 item._idleTimeoutId = setTimeout(function onTimeout() {
 if (item._onTimeout)
 item._onTimeout();
 }, msecs);
 }
};

// setimmediate attaches itself to the global object
__webpack_require__(62);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
 "use strict";

 if (global.setImmediate) {
 return;
 }

 var nextHandle = 1; // Spec says greater than zero
 var tasksByHandle = {};
 var currentlyRunningATask = false;
 var doc = global.document;
 var registerImmediate;

 function setImmediate(callback) {
 // Callback can either be a function or a string
 if (typeof callback !== "function") {
 callback = new Function("" + callback);
 }
 // Copy function arguments
 var args = new Array(arguments.length - 1);
 for (var i = 0; i < args.length; i++) {
 args[i] = arguments[i + 1];
 }
 // Store and register the task
 var task = { callback: callback, args: args };
 tasksByHandle[nextHandle] = task;
 registerImmediate(nextHandle);
 return nextHandle++;
 }

 function clearImmediate(handle) {
 delete tasksByHandle[handle];
 }

 function run(task) {
 var callback = task.callback;
 var args = task.args;
 switch (args.length) {
 case 0:
 callback();
 break;
 case 1:
 callback(args[0]);
 break;
 case 2:
 callback(args[0], args[1]);
 break;
 case 3:
 callback(args[0], args[1], args[2]);
 break;
 default:
 callback.apply(undefined, args);
 break;
 }
 }

 function runIfPresent(handle) {
 // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
 // So if we're currently running a task, we'll need to delay this invocation.
 if (currentlyRunningATask) {
 // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
 // "too much recursion" error.
 setTimeout(runIfPresent, 0, handle);
 } else {
 var task = tasksByHandle[handle];
 if (task) {
 currentlyRunningATask = true;
 try {
 run(task);
 } finally {
 clearImmediate(handle);
 currentlyRunningATask = false;
 }
 }
 }
 }

 function installNextTickImplementation() {
 registerImmediate = function(handle) {
 process.nextTick(function () { runIfPresent(handle); });
 };
 }

 function canUsePostMessage() {
 // The test against `importScripts` prevents this implementation from being installed inside a web worker,
 // where `global.postMessage` means something completely different and can't be used for this purpose.
 if (global.postMessage && !global.importScripts) {
 var postMessageIsAsynchronous = true;
 var oldOnMessage = global.onmessage;
 global.onmessage = function() {
 postMessageIsAsynchronous = false;
 };
 global.postMessage("", "*");
 global.onmessage = oldOnMessage;
 return postMessageIsAsynchronous;
 }
 }

 function installPostMessageImplementation() {
 // Installs an event handler on `global` for the `message` event: see
 // * https://developer.mozilla.org/en/DOM/window.postMessage
 // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

 var messagePrefix = "setImmediate$" + Math.random() + "$";
 var onGlobalMessage = function(event) {
 if (event.source === global &&
 typeof event.data === "string" &&
 event.data.indexOf(messagePrefix) === 0) {
 runIfPresent(+event.data.slice(messagePrefix.length));
 }
 };

 if (global.addEventListener) {
 global.addEventListener("message", onGlobalMessage, false);
 } else {
 global.attachEvent("onmessage", onGlobalMessage);
 }

 registerImmediate = function(handle) {
 global.postMessage(messagePrefix + handle, "*");
 };
 }

 function installMessageChannelImplementation() {
 var channel = new MessageChannel();
 channel.port1.onmessage = function(event) {
 var handle = event.data;
 runIfPresent(handle);
 };

 registerImmediate = function(handle) {
 channel.port2.postMessage(handle);
 };
 }

 function installReadyStateChangeImplementation() {
 var html = doc.documentElement;
 registerImmediate = function(handle) {
 // Create a ';
 }
 var iframeContents = '' + script + '';
 try {
 this.myIFrame.doc.open();
 this.myIFrame.doc.write(iframeContents);
 this.myIFrame.doc.close();
 }
 catch (e) {
 util_1.log('frame writing exception');
 if (e.stack) {
 util_1.log(e.stack);
 }
 util_1.log(e);
 }
 }
 else {
 this.commandCB = commandCB;
 this.onMessageCB = onMessageCB;
 }
 }
 /**
 * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
 * actually use.
 * @private
 * @return {Element}
 */
 FirebaseIFrameScriptHolder.createIFrame_ = function () {
 var iframe = document.createElement('iframe');
 iframe.style.display = 'none';
 // This is necessary in order to initialize the document inside the iframe
 if (document.body) {
 document.body.appendChild(iframe);
 try {
 // If document.domain has been modified in IE, this will throw an error, and we need to set the
 // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
 // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
 var a = iframe.contentWindow.document;
 if (!a) {
 // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
 util_1.log('No IE domain setting required');
 }
 }
 catch (e) {
 var domain = document.domain;
 iframe.src =
 "javascript:void((function(){document.open();document.domain='" +
 domain +
 "';document.close();})())";
 }
 }
 else {
 // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
 // never gets hit.
 throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
 }
 // Get the document of the iframe in a browser-specific way.
 if (iframe.contentDocument) {
 iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
 }
 else if (iframe.contentWindow) {
 iframe.doc = iframe.contentWindow.document; // Internet Explorer
 }
 else if (iframe.document) {
 iframe.doc = iframe.document; //others?
 }
 return iframe;
 };
 /**
 * Cancel all outstanding queries and remove the frame.
 */
 FirebaseIFrameScriptHolder.prototype.close = function () {
 var _this = this;
 //Mark this iframe as dead, so no new requests are sent.
 this.alive = false;
 if (this.myIFrame) {
 //We have to actually remove all of the html inside this iframe before removing it from the
 //window, or IE will continue loading and executing the script tags we've already added, which
 //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
 this.myIFrame.doc.body.innerHTML = '';
 setTimeout(function () {
 if (_this.myIFrame !== null) {
 document.body.removeChild(_this.myIFrame);
 _this.myIFrame = null;
 }
 }, Math.floor(0));
 }
 if (util_3.isNodeSdk() && this.myID) {
 var urlParams = {};
 urlParams[exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
 urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
 urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
 var theURL = this.urlFn(urlParams);
 FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
 }
 // Protect from being called recursively.
 var onDisconnect = this.onDisconnect;
 if (onDisconnect) {
 this.onDisconnect = null;
 onDisconnect();
 }
 };
 /**
 * Actually start the long-polling session by adding the first script tag(s) to the iframe.
 * @param {!string} id - The ID of this connection
 * @param {!string} pw - The password for this connection
 */
 FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
 this.myID = id;
 this.myPW = pw;
 this.alive = true;
 //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
 while (this.newRequest_()) { }
 };
 /**
 * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
 * too many outstanding requests and we are still alive.
 *
 * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
 * needed.
 */
 FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
 // We keep one outstanding request open all the time to receive data, but if we need to send data
 // (pendingSegs.length > 0) then we create a new request to send the data. The server will automatically
 // close the old request.
 if (this.alive &&
 this.sendNewPolls &&
 this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
 //construct our url
 this.currentSerial++;
 var urlParams = {};
 urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
 urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
 urlParams[exports.FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
 var theURL = this.urlFn(urlParams);
 //Now add as much data as we can.
 var curDataString = '';
 var i = 0;
 while (this.pendingSegs.length > 0) {
 //first, lets see if the next segment will fit.
 var nextSeg = this.pendingSegs[0];
 if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
 MAX_URL_DATA_SIZE) {
 //great, the segment will fit. Lets append it.
 var theSeg = this.pendingSegs.shift();
 curDataString =
 curDataString +
 '&' +
 exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
 i +
 '=' +
 theSeg.seg +
 '&' +
 exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
 i +
 '=' +
 theSeg.ts +
 '&' +
 exports.FIREBASE_LONGPOLL_DATA_PARAM +
 i +
 '=' +
 theSeg.d;
 i++;
 }
 else {
 break;
 }
 }
 theURL = theURL + curDataString;
 this.addLongPollTag_(theURL, this.currentSerial);
 return true;
 }
 else {
 return false;
 }
 };
 /**
 * Queue a packet for transmission to the server.
 * @param segnum - A sequential id for this packet segment used for reassembly
 * @param totalsegs - The total number of segments in this packet
 * @param data - The data for this segment.
 */
 FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
 //add this to the queue of segments to send.
 this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
 //send the data immediately if there isn't already data being transmitted, unless
 //startLongPoll hasn't been called yet.
 if (this.alive) {
 this.newRequest_();
 }
 };
 /**
 * Add a script tag for a regular long-poll request.
 * @param {!string} url - The URL of the script tag.
 * @param {!number} serial - The serial number of the request.
 * @private
 */
 FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
 var _this = this;
 //remember that we sent this request.
 this.outstandingRequests.add(serial, 1);
 var doNewRequest = function () {
 _this.outstandingRequests.remove(serial);
 _this.newRequest_();
 };
 // If this request doesn't return on its own accord (by the server sending us some data), we'll
 // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
 var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
 var readyStateCB = function () {
 // Request completed. Cancel the keepalive.
 clearTimeout(keepaliveTimeout);
 // Trigger a new request so we can continue receiving data.
 doNewRequest();
 };
 this.addTag(url, readyStateCB);
 };
 /**
 * Add an arbitrary script tag to the iframe.
 * @param {!string} url - The URL for the script tag source.
 * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
 */
 FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
 var _this = this;
 if (util_3.isNodeSdk()) {
 this.doNodeLongPoll(url, loadCB);
 }
 else {
 setTimeout(function () {
 try {
 // if we're already closed, don't add this poll
 if (!_this.sendNewPolls)
 return;
 var newScript_1 = _this.myIFrame.doc.createElement('script');
 newScript_1.type = 'text/javascript';
 newScript_1.async = true;
 newScript_1.src = url;
 newScript_1.onload = newScript_1.onreadystatechange = function () {
 var rstate = newScript_1.readyState;
 if (!rstate || rstate === 'loaded' || rstate === 'complete') {
 newScript_1.onload = newScript_1.onreadystatechange = null;
 if (newScript_1.parentNode) {
 newScript_1.parentNode.removeChild(newScript_1);
 }
 loadCB();
 }
 };
 newScript_1.onerror = function () {
 util_1.log('Long-poll script failed to load: ' + url);
 _this.sendNewPolls = false;
 _this.close();
 };
 _this.myIFrame.doc.body.appendChild(newScript_1);
 }
 catch (e) {
 // TODO: we should make this error visible somehow
 }
 }, Math.floor(1));
 }
 };
 return FirebaseIFrameScriptHolder;
}());
exports.FirebaseIFrameScriptHolder = FirebaseIFrameScriptHolder;

//# sourceMappingURL=BrowserPollConnection.js.map


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __webpack_require__(6);
var util_1 = __webpack_require__(0);
var util_2 = __webpack_require__(1);
var StatsManager_1 = __webpack_require__(25);
var Constants_1 = __webpack_require__(13);
var util_3 = __webpack_require__(0);
var storage_1 = __webpack_require__(12);
var util_4 = __webpack_require__(0);
var util_5 = __webpack_require__(0);
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
 WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
 WebSocketImpl = WebSocket;
}
function setWebSocketImpl(impl) {
 WebSocketImpl = impl;
}
exports.setWebSocketImpl = setWebSocketImpl;
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
 /**
 * @param {string} connId identifier for this transport
 * @param {RepoInfo} repoInfo The info for the websocket endpoint.
 * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
 * session
 * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
 */
 function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
 this.connId = connId;
 this.keepaliveTimer = null;
 this.frames = null;
 this.totalFrames = 0;
 this.bytesSent = 0;
 this.bytesReceived = 0;
 this.log_ = util_2.logWrapper(this.connId);
 this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo);
 this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
 }
 /**
 * @param {RepoInfo} repoInfo The info for the websocket endpoint.
 * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
 * session
 * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
 * @return {string} connection url
 * @private
 */
 WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
 var urlParams = {};
 urlParams[Constants_1.VERSION_PARAM] = Constants_1.PROTOCOL_VERSION;
 if (!util_5.isNodeSdk() &&
 typeof location !== 'undefined' &&
 location.href &&
 location.href.indexOf(Constants_1.FORGE_DOMAIN) !== -1) {
 urlParams[Constants_1.REFERER_PARAM] = Constants_1.FORGE_REF;
 }
 if (transportSessionId) {
 urlParams[Constants_1.TRANSPORT_SESSION_PARAM] = transportSessionId;
 }
 if (lastSessionId) {
 urlParams[Constants_1.LAST_SESSION_PARAM] = lastSessionId;
 }
 return repoInfo.connectionURL(Constants_1.WEBSOCKET, urlParams);
 };
 /**
 *
 * @param onMessage Callback when messages arrive
 * @param onDisconnect Callback with connection lost.
 */
 WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
 var _this = this;
 this.onDisconnect = onDisconnect;
 this.onMessage = onMessage;
 this.log_('Websocket connecting to ' + this.connURL);
 this.everConnected_ = false;
 // Assume failure until proven otherwise.
 storage_1.PersistentStorage.set('previous_websocket_failure', true);
 try {
 if (util_5.isNodeSdk()) {
 var device = util_3.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
 // UA Format: Firebase////
 var options = {
 headers: {
 'User-Agent': "Firebase/" + Constants_1.PROTOCOL_VERSION + "/" + app_1.default.SDK_VERSION + "/" + process.platform + "/" + device
 }
 };
 // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
 var env = process['env'];
 var proxy = this.connURL.indexOf('wss://') == 0
 ? env['HTTPS_PROXY'] || env['https_proxy']
 : env['HTTP_PROXY'] || env['http_proxy'];
 if (proxy) {
 options['proxy'] = { origin: proxy };
 }
 this.mySock = new WebSocketImpl(this.connURL, [], options);
 }
 else {
 this.mySock = new WebSocketImpl(this.connURL);
 }
 }
 catch (e) {
 this.log_('Error instantiating WebSocket.');
 var error = e.message || e.data;
 if (error) {
 this.log_(error);
 }
 this.onClosed_();
 return;
 }
 this.mySock.onopen = function () {
 _this.log_('Websocket connected.');
 _this.everConnected_ = true;
 };
 this.mySock.onclose = function () {
 _this.log_('Websocket connection was disconnected.');
 _this.mySock = null;
 _this.onClosed_();
 };
 this.mySock.onmessage = function (m) {
 _this.handleIncomingFrame(m);
 };
 this.mySock.onerror = function (e) {
 _this.log_('WebSocket error. Closing connection.');
 var error = e.message || e.data;
 if (error) {
 _this.log_(error);
 }
 _this.onClosed_();
 };
 };
 /**
 * No-op for websockets, we don't need to do anything once the connection is confirmed as open
 */
 WebSocketConnection.prototype.start = function () { };
 WebSocketConnection.forceDisallow = function () {
 WebSocketConnection.forceDisallow_ = true;
 };
 WebSocketConnection.isAvailable = function () {
 var isOldAndroid = false;
 if (typeof navigator !== 'undefined' && navigator.userAgent) {
 var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
 var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
 if (oldAndroidMatch && oldAndroidMatch.length > 1) {
 if (parseFloat(oldAndroidMatch[1]) < 4.4) {
 isOldAndroid = true;
 }
 }
 }
 return (!isOldAndroid &&
 WebSocketImpl !== null &&
 !WebSocketConnection.forceDisallow_);
 };
 /**
 * Returns true if we previously failed to connect with this transport.
 * @return {boolean}
 */
 WebSocketConnection.previouslyFailed = function () {
 // If our persistent storage is actually only in-memory storage,
 // we default to assuming that it previously failed to be safe.
 return (storage_1.PersistentStorage.isInMemoryStorage ||
 storage_1.PersistentStorage.get('previous_websocket_failure') === true);
 };
 WebSocketConnection.prototype.markConnectionHealthy = function () {
 storage_1.PersistentStorage.remove('previous_websocket_failure');
 };
 WebSocketConnection.prototype.appendFrame_ = function (data) {
 this.frames.push(data);
 if (this.frames.length == this.totalFrames) {
 var fullMess = this.frames.join('');
 this.frames = null;
 var jsonMess = util_4.jsonEval(fullMess);
 //handle the message
 this.onMessage(jsonMess);
 }
 };
 /**
 * @param {number} frameCount The number of frames we are expecting from the server
 * @private
 */
 WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
 this.totalFrames = frameCount;
 this.frames = [];
 };
 /**
 * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
 * @param {!String} data
 * @return {?String} Any remaining data to be process, or null if there is none
 * @private
 */
 WebSocketConnection.prototype.extractFrameCount_ = function (data) {
 util_1.assert(this.frames === null, 'We already have a frame buffer');
 // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
 // currently. So allowing larger frame counts (length <= 6). See https://app.asana.com/0/search/8688598998380/8237608042508
 if (data.length <= 6) {
 var frameCount = Number(data);
 if (!isNaN(frameCount)) {
 this.handleNewFrameCount_(frameCount);
 return null;
 }
 }
 this.handleNewFrameCount_(1);
 return data;
 };
 /**
 * Process a websocket frame that has arrived from the server.
 * @param mess The frame data
 */
 WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
 if (this.mySock === null)
 return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
 var data = mess['data'];
 this.bytesReceived += data.length;
 this.stats_.incrementCounter('bytes_received', data.length);
 this.resetKeepAlive();
 if (this.frames !== null) {
 // we're buffering
 this.appendFrame_(data);
 }
 else {
 // try to parse out a frame count, otherwise, assume 1 and process it
 var remainingData = this.extractFrameCount_(data);
 if (remainingData !== null) {
 this.appendFrame_(remainingData);
 }
 }
 };
 /**
 * Send a message to the server
 * @param {Object} data The JSON object to transmit
 */
 WebSocketConnection.prototype.send = function (data) {
 this.resetKeepAlive();
 var dataStr = util_4.stringify(data);
 this.bytesSent += dataStr.length;
 this.stats_.incrementCounter('bytes_sent', dataStr.length);
 //We can only fit a certain amount in each websocket frame, so we need to split this request
 //up into multiple pieces if it doesn't fit in one request.
 var dataSegs = util_2.splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
 //Send the length header
 if (dataSegs.length > 1) {
 this.sendString_(String(dataSegs.length));
 }
 //Send the actual data in segments.
 for (var i = 0; i < dataSegs.length; i++) {
 this.sendString_(dataSegs[i]);
 }
 };
 WebSocketConnection.prototype.shutdown_ = function () {
 this.isClosed_ = true;
 if (this.keepaliveTimer) {
 clearInterval(this.keepaliveTimer);
 this.keepaliveTimer = null;
 }
 if (this.mySock) {
 this.mySock.close();
 this.mySock = null;
 }
 };
 WebSocketConnection.prototype.onClosed_ = function () {
 if (!this.isClosed_) {
 this.log_('WebSocket is closing itself');
 this.shutdown_();
 // since this is an internal close, trigger the close listener
 if (this.onDisconnect) {
 this.onDisconnect(this.everConnected_);
 this.onDisconnect = null;
 }
 }
 };
 /**
 * External-facing close handler.
 * Close the websocket and kill the connection.
 */
 WebSocketConnection.prototype.close = function () {
 if (!this.isClosed_) {
 this.log_('WebSocket is being closed');
 this.shutdown_();
 }
 };
 /**
 * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
 * the last activity.
 */
 WebSocketConnection.prototype.resetKeepAlive = function () {
 var _this = this;
 clearInterval(this.keepaliveTimer);
 this.keepaliveTimer = setInterval(function () {
 //If there has been no websocket activity for a while, send a no-op
 if (_this.mySock) {
 _this.sendString_('0');
 }
 _this.resetKeepAlive();
 }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
 };
 /**
 * Send a string over the websocket.
 *
 * @param {string} str String to send.
 * @private
 */
 WebSocketConnection.prototype.sendString_ = function (str) {
 // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
 // calls for some unknown reason. We treat these as an error and disconnect.
 // See https://app.asana.com/0/58926111402292/68021340250410
 try {
 this.mySock.send(str);
 }
 catch (e) {
 this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
 setTimeout(this.onClosed_.bind(this), 0);
 }
 };
 /**
 * Number of response before we consider the connection "healthy."
 * @type {number}
 */
 WebSocketConnection.responsesRequiredToBeHealthy = 2;
 /**
 * Time to wait for the connection te become healthy before giving up.
 * @type {number}
 */
 WebSocketConnection.healthyTimeout = 30000;
 return WebSocketConnection;
}());
exports.WebSocketConnection = WebSocketConnection;

//# sourceMappingURL=WebSocketConnection.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
 function ServerActions() {
 }
 /**
 * @param {string} pathString
 * @param {*} data
 * @param {function(string, string)=} onComplete
 * @param {string=} hash
 */
 ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
 /**
 * @param {string} pathString
 * @param {*} data
 * @param {function(string, ?string)} onComplete
 * @param {string=} hash
 */
 ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
 /**
 * Refreshes the auth token for the current connection.
 * @param {string} token The authentication token
 */
 ServerActions.prototype.refreshAuthToken = function (token) { };
 /**
 * @param {string} pathString
 * @param {*} data
 * @param {function(string, string)=} onComplete
 */
 ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
 /**
 * @param {string} pathString
 * @param {*} data
 * @param {function(string, string)=} onComplete
 */
 ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
 /**
 * @param {string} pathString
 * @param {function(string, string)=} onComplete
 */
 ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
 /**
 * @param {Object.} stats
 */
 ServerActions.prototype.reportStats = function (stats) { };
 return ServerActions;
}());
exports.ServerActions = ServerActions;

//# sourceMappingURL=ServerActions.js.map


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedFilter_1 = __webpack_require__(24);
var PriorityIndex_1 = __webpack_require__(3);
var Node_1 = __webpack_require__(5);
var ChildrenNode_1 = __webpack_require__(4);
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
 /**
 * @param {!QueryParams} params
 */
 function RangedFilter(params) {
 this.indexedFilter_ = new IndexedFilter_1.IndexedFilter(params.getIndex());
 this.index_ = params.getIndex();
 this.startPost_ = RangedFilter.getStartPost_(params);
 this.endPost_ = RangedFilter.getEndPost_(params);
 }
 /**
 * @return {!NamedNode}
 */
 RangedFilter.prototype.getStartPost = function () {
 return this.startPost_;
 };
 /**
 * @return {!NamedNode}
 */
 RangedFilter.prototype.getEndPost = function () {
 return this.endPost_;
 };
 /**
 * @param {!NamedNode} node
 * @return {boolean}
 */
 RangedFilter.prototype.matches = function (node) {
 return (this.index_.compare(this.getStartPost(), node) <= 0 &&
 this.index_.compare(node, this.getEndPost()) <= 0);
 };
 /**
 * @inheritDoc
 */
 RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
 if (!this.matches(new Node_1.NamedNode(key, newChild))) {
 newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 }
 return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
 };
 /**
 * @inheritDoc
 */
 RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
 if (newSnap.isLeafNode()) {
 // Make sure we have a children node with the correct index, not a leaf node;
 newSnap = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 }
 var filtered = newSnap.withIndex(this.index_);
 // Don't support priorities on queries
 filtered = filtered.updatePriority(ChildrenNode_1.ChildrenNode.EMPTY_NODE);
 var self = this;
 newSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
 if (!self.matches(new Node_1.NamedNode(key, childNode))) {
 filtered = filtered.updateImmediateChild(key, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
 }
 });
 return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
 };
 /**
 * @inheritDoc
 */
 RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
 // Don't support priorities on queries
 return oldSnap;
 };
 /**
 * @inheritDoc
 */
 RangedFilter.prototype.filtersNodes = function () {
 return true;
 };
 /**
 * @inheritDoc
 */
 RangedFilter.prototype.getIndexedFilter = function () {
 return this.indexedFilter_;
 };
 /**
 * @inheritDoc
 */
 RangedFilter.prototype.getIndex = function () {
 return this.index_;
 };
 /**
 * @param {!QueryParams} params
 * @return {!NamedNode}
 * @private
 */
 RangedFilter.getStartPost_ = function (params) {
 if (params.hasStart()) {
 var startName = params.getIndexStartName();
 return params.getIndex().makePost(params.getIndexStartValue(), startName);
 }
 else {
 return params.getIndex().minPost();
 }
 };
 /**
 * @param {!QueryParams} params
 * @return {!NamedNode}
 * @private
 */
 RangedFilter.getEndPost_ = function (params) {
 if (params.hasEnd()) {
 var endName = params.getIndexEndName();
 return params.getIndex().makePost(params.getIndexEndValue(), endName);
 }
 else {
 return params.getIndex().maxPost();
 }
 };
 return RangedFilter;
}());
exports.RangedFilter = RangedFilter;

//# sourceMappingURL=RangedFilter.js.map


/***/ }),
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = __webpack_require__(79);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __webpack_require__(6);
var Database_1 = __webpack_require__(32);
exports.Database = Database_1.Database;
var Query_1 = __webpack_require__(36);
exports.Query = Query_1.Query;
var Reference_1 = __webpack_require__(21);
exports.Reference = Reference_1.Reference;
var util_1 = __webpack_require__(1);
exports.enableLogging = util_1.enableLogging;
var RepoManager_1 = __webpack_require__(26);
var INTERNAL = __webpack_require__(111);
var TEST_ACCESS = __webpack_require__(112);
var util_2 = __webpack_require__(0);
var ServerValue = Database_1.Database.ServerValue;
exports.ServerValue = ServerValue;
function registerDatabase(instance) {
 // Register the Database Service with the 'firebase' namespace.
 var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager_1.RepoManager.getInstance().databaseFromApp(app, url); }, 
 // firebase.database namespace properties
 {
 Reference: Reference_1.Reference,
 Query: Query_1.Query,
 Database: Database_1.Database,
 enableLogging: util_1.enableLogging,
 INTERNAL: INTERNAL,
 ServerValue: ServerValue,
 TEST_ACCESS: TEST_ACCESS
 }, null, true);
 if (util_2.isNodeSdk()) {
 module.exports = namespace;
 }
}
exports.registerDatabase = registerDatabase;
registerDatabase(app_1.default);
var DataSnapshot_1 = __webpack_require__(22);
exports.DataSnapshot = DataSnapshot_1.DataSnapshot;
var onDisconnect_1 = __webpack_require__(35);
exports.OnDisconnect = onDisconnect_1.OnDisconnect;

//# sourceMappingURL=index.js.map


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
 /**
 * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
 */
 function DOMStorageWrapper(domStorage_) {
 this.domStorage_ = domStorage_;
 // Use a prefix to avoid collisions with other stuff saved by the app.
 this.prefix_ = 'firebase:';
 }
 /**
 * @param {string} key The key to save the value under
 * @param {?Object} value The value being stored, or null to remove the key.
 */
 DOMStorageWrapper.prototype.set = function (key, value) {
 if (value == null) {
 this.domStorage_.removeItem(this.prefixedName_(key));
 }
 else {
 this.domStorage_.setItem(this.prefixedName_(key), util_1.stringify(value));
 }
 };
 /**
 * @param {string} key
 * @return {*} The value that was stored under this key, or null
 */
 DOMStorageWrapper.prototype.get = function (key) {
 var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
 if (storedVal == null) {
 return null;
 }
 else {
 return util_1.jsonEval(storedVal);
 }
 };
 /**
 * @param {string} key
 */
 DOMStorageWrapper.prototype.remove = function (key) {
 this.domStorage_.removeItem(this.prefixedName_(key));
 };
 /**
 * @param {string} name
 * @return {string}
 */
 DOMStorageWrapper.prototype.prefixedName_ = function (name) {
 return this.prefix_ + name;
 };
 DOMStorageWrapper.prototype.toString = function () {
 return this.domStorage_.toString();
 };
 return DOMStorageWrapper;
}());
exports.DOMStorageWrapper = DOMStorageWrapper;

//# sourceMappingURL=DOMStorageWrapper.js.map


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
 function MemoryStorage() {
 this.cache_ = {};
 this.isInMemoryStorage = true;
 }
 MemoryStorage.prototype.set = function (key, value) {
 if (value == null) {
 delete this.cache_[key];
 }
 else {
 this.cache_[key] = value;
 }
 };
 MemoryStorage.prototype.get = function (key) {
 if (util_1.contains(this.cache_, key)) {
 return this.cache_[key];
 }
 return null;
 };
 MemoryStorage.prototype.remove = function (key) {
 delete this.cache_[key];
 };
 return MemoryStorage;
}());
exports.MemoryStorage = MemoryStorage;

//# sourceMappingURL=MemoryStorage.js.map


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var TransactionResult = /** @class */ (function () {
 /**
 * A type for the resolve value of Firebase.transaction.
 * @constructor
 * @dict
 * @param {boolean} committed
 * @param {DataSnapshot} snapshot
 */
 function TransactionResult(committed, snapshot) {
 this.committed = committed;
 this.snapshot = snapshot;
 }
 // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
 // for end-users
 TransactionResult.prototype.toJSON = function () {
 util_1.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
 return { committed: this.committed, snapshot: this.snapshot.toJSON() };
 };
 return TransactionResult;
}());
exports.TransactionResult = TransactionResult;

//# sourceMappingURL=TransactionResult.js.map


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 * collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 * that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 * the same timestamp, the latter ones will sort after the former ones. We do
 * this by using the previous random bits but "incrementing" them by 1 (only
 * in the case of a timestamp collision).
 */
exports.nextPushId = (function () {
 // Modeled after base64 web-safe chars, but ordered by ASCII.
 var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
 // Timestamp of last push, used to prevent local collisions if you push twice
 // in one ms.
 var lastPushTime = 0;
 // We generate 72-bits of randomness which get turned into 12 characters and
 // appended to the timestamp to prevent collisions with other clients. We
 // store the last characters we generated because in the event of a collision,
 // we'll use those same characters except "incremented" by one.
 var lastRandChars = [];
 return function (now) {
 var duplicateTime = now === lastPushTime;
 lastPushTime = now;
 var i;
 var timeStampChars = new Array(8);
 for (i = 7; i >= 0; i--) {
 timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
 // NOTE: Can't use << here because javascript will convert to int and lose
 // the upper bits.
 now = Math.floor(now / 64);
 }
 util_1.assert(now === 0, 'Cannot push at time == 0');
 var id = timeStampChars.join('');
 if (!duplicateTime) {
 for (i = 0; i < 12; i++) {
 lastRandChars[i] = Math.floor(Math.random() * 64);
 }
 }
 else {
 // If the timestamp hasn't changed since last push, use the same random
 // number, except incremented by 1.
 for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
 lastRandChars[i] = 0;
 }
 lastRandChars[i]++;
 }
 for (i = 0; i < 12; i++) {
 id += PUSH_CHARS.charAt(lastRandChars[i]);
 }
 util_1.assert(id.length === 20, 'nextPushId: Length should be 20.');
 return id;
 };
})();

//# sourceMappingURL=NextPushId.js.map


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var DataSnapshot_1 = __webpack_require__(22);
var Event_1 = __webpack_require__(85);
var util_1 = __webpack_require__(0);
var util_2 = __webpack_require__(0);
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
 /**
 * @param {?function(!DataSnapshot)} callback_
 * @param {?function(Error)} cancelCallback_
 * @param {?Object} context_
 */
 function ValueEventRegistration(callback_, cancelCallback_, context_) {
 this.callback_ = callback_;
 this.cancelCallback_ = cancelCallback_;
 this.context_ = context_;
 }
 /**
 * @inheritDoc
 */
 ValueEventRegistration.prototype.respondsTo = function (eventType) {
 return eventType === 'value';
 };
 /**
 * @inheritDoc
 */
 ValueEventRegistration.prototype.createEvent = function (change, query) {
 var index = query.getQueryParams().getIndex();
 return new Event_1.DataEvent('value', this, new DataSnapshot_1.DataSnapshot(change.snapshotNode, query.getRef(), index));
 };
 /**
 * @inheritDoc
 */
 ValueEventRegistration.prototype.getEventRunner = function (eventData) {
 var ctx = this.context_;
 if (eventData.getEventType() === 'cancel') {
 util_2.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
 var cancelCB_1 = this.cancelCallback_;
 return function () {
 // We know that error exists, we checked above that this is a cancel event
 cancelCB_1.call(ctx, eventData.error);
 };
 }
 else {
 var cb_1 = this.callback_;
 return function () {
 cb_1.call(ctx, eventData.snapshot);
 };
 }
 };
 /**
 * @inheritDoc
 */
 ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
 if (this.cancelCallback_) {
 return new Event_1.CancelEvent(this, error, path);
 }
 else {
 return null;
 }
 };
 /**
 * @inheritDoc
 */
 ValueEventRegistration.prototype.matches = function (other) {
 if (!(other instanceof ValueEventRegistration)) {
 return false;
 }
 else if (!other.callback_ || !this.callback_) {
 // If no callback specified, we consider it to match any callback.
 return true;
 }
 else {
 return (other.callback_ === this.callback_ && other.context_ === this.context_);
 }
 };
 /**
 * @inheritDoc
 */
 ValueEventRegistration.prototype.hasAnyCallback = function () {
 return this.callback_ !== null;
 };
 return ValueEventRegistration;
}());
exports.ValueEventRegistration = ValueEventRegistration;
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
 /**
 * @param {?Object.} callbacks_
 * @param {?function(Error)} cancelCallback_
 * @param {Object=} context_
 */
 function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
 this.callbacks_ = callbacks_;
 this.cancelCallback_ = cancelCallback_;
 this.context_ = context_;
 }
 /**
 * @inheritDoc
 */
 ChildEventRegistration.prototype.respondsTo = function (eventType) {
 var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
 eventToCheck =
 eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
 return util_1.contains(this.callbacks_, eventToCheck);
 };
 /**
 * @inheritDoc
 */
 ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
 if (this.cancelCallback_) {
 return new Event_1.CancelEvent(this, error, path);
 }
 else {
 return null;
 }
 };
 /**
 * @inheritDoc
 */
 ChildEventRegistration.prototype.createEvent = function (change, query) {
 util_2.assert(change.childName != null, 'Child events should have a childName.');
 var ref = query.getRef().child(/** @type {!string} */ (change.childName));
 var index = query.getQueryParams().getIndex();
 return new Event_1.DataEvent(change.type, this, new DataSnapshot_1.DataSnapshot(change.snapshotNode, ref, index), change.prevName);
 };
 /**
 * @inheritDoc
 */
 ChildEventRegistration.prototype.getEventRunner = function (eventData) {
 var ctx = this.context_;
 if (eventData.getEventType() === 'cancel') {
 util_2.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
 var cancelCB_2 = this.cancelCallback_;
 return function () {
 // We know that error exists, we checked above that this is a cancel event
 cancelCB_2.call(ctx, eventData.error);
 };
 }
 else {
 var cb_2 = this.callbacks_[eventData.eventType];
 return function () {
 cb_2.call(ctx, eventData.snapshot, eventData.prevName);
 };
 }
 };
 /**
 * @inheritDoc
 */
 ChildEventRegistration.prototype.matches = function (other) {
 if (other instanceof ChildEventRegistration) {
 if (!this.callbacks_ || !other.callbacks_) {
 return true;
 }
 else if (this.context_ === other.context_) {
 var otherCount = util_1.getCount(other.callbacks_);
 var thisCount = util_1.getCount(this.callbacks_);
 if (otherCount === thisCount) {
 // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
 // If event types don't match, not a match
 // If count is not 1, exact match across all
 if (otherCount === 1) {
 var otherKey /** @type {!string} */ = util_1.getAnyKey(other.callbacks_);
 var thisKey /** @type {!string} */ = util_1.getAnyKey(this.callbacks_);
 return (thisKey === otherKey &&
 (!other.callbacks_[otherKey] ||
 !this.callbacks_[thisKey] ||
 other.callbacks_[otherKey] === this.callbacks_[thisKey]));
 }
 else {
 // Exact match on each key.
 return util_1.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
 }
 }
 }
 }
 return false;
 };
 /**
 * @inheritDoc
 */
 ChildEventRegistration.prototype.hasAnyCallback = function () {
 return this.callbacks_ !== null;
 };
 return ChildEventRegistration;
}());
exports.ChildEventRegistration = ChildEventRegistration;

//# sourceMappingURL=EventRegistration.js.map


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
 /**
 * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
 * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
 * @param {!DataSnapshot} snapshot The data backing the event
 * @param {?string=} prevName Optional, the name of the previous child for child_* events.
 */
 function DataEvent(eventType, eventRegistration, snapshot, prevName) {
 this.eventType = eventType;
 this.eventRegistration = eventRegistration;
 this.snapshot = snapshot;
 this.prevName = prevName;
 }
 /**
 * @inheritDoc
 */
 DataEvent.prototype.getPath = function () {
 var ref = this.snapshot.getRef();
 if (this.eventType === 'value') {
 return ref.path;
 }
 else {
 return ref.getParent().path;
 }
 };
 /**
 * @inheritDoc
 */
 DataEvent.prototype.getEventType = function () {
 return this.eventType;
 };
 /**
 * @inheritDoc
 */
 DataEvent.prototype.getEventRunner = function () {
 return this.eventRegistration.getEventRunner(this);
 };
 /**
 * @inheritDoc
 */
 DataEvent.prototype.toString = function () {
 return (this.getPath().toString() +
 ':' +
 this.eventType +
 ':' +
 util_1.stringify(this.snapshot.exportVal()));
 };
 return DataEvent;
}());
exports.DataEvent = DataEvent;
var CancelEvent = /** @class */ (function () {
 /**
 * @param {EventRegistration} eventRegistration
 * @param {Error} error
 * @param {!Path} path
 */
 function CancelEvent(eventRegistration, error, path) {
 this.eventRegistration = eventRegistration;
 this.error = error;
 this.path = path;
 }
 /**
 * @inheritDoc
 */
 CancelEvent.prototype.getPath = function () {
 return this.path;
 };
 /**
 * @inheritDoc
 */
 CancelEvent.prototype.getEventType = function () {
 return 'cancel';
 };
 /**
 * @inheritDoc
 */
 CancelEvent.prototype.getEventRunner = function () {
 return this.eventRegistration.getEventRunner(this);
 };
 /**
 * @inheritDoc
 */
 CancelEvent.prototype.toString = function () {
 return this.path.toString() + ':cancel';
 };
 return CancelEvent;
}());
exports.CancelEvent = CancelEvent;

//# sourceMappingURL=Event.js.map


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var util_2 = __webpack_require__(1);
var AckUserWrite_1 = __webpack_require__(87);
var ChildrenNode_1 = __webpack_require__(4);
var util_3 = __webpack_require__(0);
var ImmutableTree_1 = __webpack_require__(23);
var ListenComplete_1 = __webpack_require__(88);
var Merge_1 = __webpack_require__(89);
var Operation_1 = __webpack_require__(8);
var Overwrite_1 = __webpack_require__(46);
var Path_1 = __webpack_require__(2);
var SyncPoint_1 = __webpack_require__(47);
var WriteTree_1 = __webpack_require__(95);
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation. There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 * - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 * - Applying and caching data changes for user set(), transaction(), and update() calls
 * (applyUserOverwrite(), applyUserMerge()).
 * - Applying and caching data changes for server data changes (applyServerOverwrite(),
 * applyServerMerge()).
 * - Generating user-facing events for server and user changes (all of the apply* methods
 * return the set of events that need to be raised as a result).
 * - Maintaining the appropriate set of server listens to ensure we are always subscribed
 * to the correct set of paths and queries to satisfy the current set of user event
 * callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
 /**
 * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
 * to server data.
 */
 function SyncTree(listenProvider_) {
 this.listenProvider_ = listenProvider_;
 /**
 * Tree of SyncPoints. There's a SyncPoint at any location that has 1 or more views.
 * @type {!ImmutableTree.}
 * @private
 */
 this.syncPointTree_ = ImmutableTree_1.ImmutableTree.Empty;
 /**
 * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
 * @type {!WriteTree}
 * @private
 */
 this.pendingWriteTree_ = new WriteTree_1.WriteTree();
 this.tagToQueryMap_ = {};
 this.queryToTagMap_ = {};
 }
 /**
 * Apply the data changes for a user-generated set() or transaction() call.
 *
 * @param {!Path} path
 * @param {!Node} newData
 * @param {number} writeId
 * @param {boolean=} visible
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
 // Record pending write.
 this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
 if (!visible) {
 return [];
 }
 else {
 return this.applyOperationToSyncPoints_(new Overwrite_1.Overwrite(Operation_1.OperationSource.User, path, newData));
 }
 };
 /**
 * Apply the data from a user-generated update() call
 *
 * @param {!Path} path
 * @param {!Object.} changedChildren
 * @param {!number} writeId
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
 // Record pending merge.
 this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
 var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
 return this.applyOperationToSyncPoints_(new Merge_1.Merge(Operation_1.OperationSource.User, path, changeTree));
 };
 /**
 * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
 *
 * @param {!number} writeId
 * @param {boolean=} revert True if the given write failed and needs to be reverted
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.ackUserWrite = function (writeId, revert) {
 if (revert === void 0) { revert = false; }
 var write = this.pendingWriteTree_.getWrite(writeId);
 var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
 if (!needToReevaluate) {
 return [];
 }
 else {
 var affectedTree_1 = ImmutableTree_1.ImmutableTree.Empty;
 if (write.snap != null) {
 // overwrite
 affectedTree_1 = affectedTree_1.set(Path_1.Path.Empty, true);
 }
 else {
 util_3.forEach(write.children, function (pathString, node) {
 affectedTree_1 = affectedTree_1.set(new Path_1.Path(pathString), node);
 });
 }
 return this.applyOperationToSyncPoints_(new AckUserWrite_1.AckUserWrite(write.path, affectedTree_1, revert));
 }
 };
 /**
 * Apply new server data for the specified path..
 *
 * @param {!Path} path
 * @param {!Node} newData
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.applyServerOverwrite = function (path, newData) {
 return this.applyOperationToSyncPoints_(new Overwrite_1.Overwrite(Operation_1.OperationSource.Server, path, newData));
 };
 /**
 * Apply new server data to be merged in at the specified path.
 *
 * @param {!Path} path
 * @param {!Object.} changedChildren
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
 var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
 return this.applyOperationToSyncPoints_(new Merge_1.Merge(Operation_1.OperationSource.Server, path, changeTree));
 };
 /**
 * Apply a listen complete for a query
 *
 * @param {!Path} path
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.applyListenComplete = function (path) {
 return this.applyOperationToSyncPoints_(new ListenComplete_1.ListenComplete(Operation_1.OperationSource.Server, path));
 };
 /**
 * Apply new server data for the specified tagged query.
 *
 * @param {!Path} path
 * @param {!Node} snap
 * @param {!number} tag
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
 var queryKey = this.queryKeyForTag_(tag);
 if (queryKey != null) {
 var r = SyncTree.parseQueryKey_(queryKey);
 var queryPath = r.path, queryId = r.queryId;
 var relativePath = Path_1.Path.relativePath(queryPath, path);
 var op = new Overwrite_1.Overwrite(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
 return this.applyTaggedOperation_(queryPath, op);
 }
 else {
 // Query must have been removed already
 return [];
 }
 };
 /**
 * Apply server data to be merged in for the specified tagged query.
 *
 * @param {!Path} path
 * @param {!Object.} changedChildren
 * @param {!number} tag
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
 var queryKey = this.queryKeyForTag_(tag);
 if (queryKey) {
 var r = SyncTree.parseQueryKey_(queryKey);
 var queryPath = r.path, queryId = r.queryId;
 var relativePath = Path_1.Path.relativePath(queryPath, path);
 var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
 var op = new Merge_1.Merge(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
 return this.applyTaggedOperation_(queryPath, op);
 }
 else {
 // We've already removed the query. No big deal, ignore the update
 return [];
 }
 };
 /**
 * Apply a listen complete for a tagged query
 *
 * @param {!Path} path
 * @param {!number} tag
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
 var queryKey = this.queryKeyForTag_(tag);
 if (queryKey) {
 var r = SyncTree.parseQueryKey_(queryKey);
 var queryPath = r.path, queryId = r.queryId;
 var relativePath = Path_1.Path.relativePath(queryPath, path);
 var op = new ListenComplete_1.ListenComplete(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath);
 return this.applyTaggedOperation_(queryPath, op);
 }
 else {
 // We've already removed the query. No big deal, ignore the update
 return [];
 }
 };
 /**
 * Add an event callback for the specified query.
 *
 * @param {!Query} query
 * @param {!EventRegistration} eventRegistration
 * @return {!Array.} Events to raise.
 */
 SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
 var path = query.path;
 var serverCache = null;
 var foundAncestorDefaultView = false;
 // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
 // Consider optimizing this once there's a better understanding of what actual behavior will be.
 this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
 var relativePath = Path_1.Path.relativePath(pathToSyncPoint, path);
 serverCache = serverCache || sp.getCompleteServerCache(relativePath);
 foundAncestorDefaultView =
 foundAncestorDefaultView || sp.hasCompleteView();
 });
 var syncPoint = this.syncPointTree_.get(path);
 if (!syncPoint) {
 syncPoint = new SyncPoint_1.SyncPoint();
 this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
 }
 else {
 foundAncestorDefaultView =
 foundAncestorDefaultView || syncPoint.hasCompleteView();
 serverCache = serverCache || syncPoint.getCompleteServerCache(Path_1.Path.Empty);
 }
 var serverCacheComplete;
 if (serverCache != null) {
 serverCacheComplete = true;
 }
 else {
 serverCacheComplete = false;
 serverCache = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 var subtree = this.syncPointTree_.subtree(path);
 subtree.foreachChild(function (childName, childSyncPoint) {
 var completeCache = childSyncPoint.getCompleteServerCache(Path_1.Path.Empty);
 if (completeCache) {
 serverCache = serverCache.updateImmediateChild(childName, completeCache);
 }
 });
 }
 var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
 if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
 // We need to track a tag for this query
 var queryKey = SyncTree.makeQueryKey_(query);
 util_1.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
 var tag = SyncTree.getNextQueryTag_();
 this.queryToTagMap_[queryKey] = tag;
 // Coerce to string to avoid sparse arrays.
 this.tagToQueryMap_['_' + tag] = queryKey;
 }
 var writesCache = this.pendingWriteTree_.childWrites(path);
 var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
 if (!viewAlreadyExists && !foundAncestorDefaultView) {
 var view /** @type !View */ = syncPoint.viewForQuery(query);
 events = events.concat(this.setupListener_(query, view));
 }
 return events;
 };
 /**
 * Remove event callback(s).
 *
 * If query is the default query, we'll check all queries for the specified eventRegistration.
 * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
 *
 * @param {!Query} query
 * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
 * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
 * @return {!Array.} Cancel events, if cancelError was provided.
 */
 SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
 var _this = this;
 // Find the syncPoint first. Then deal with whether or not it has matching listeners
 var path = query.path;
 var maybeSyncPoint = this.syncPointTree_.get(path);
 var cancelEvents = [];
 // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
 // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
 // not loadsAllData().
 if (maybeSyncPoint &&
 (query.queryIdentifier() === 'default' ||
 maybeSyncPoint.viewExistsForQuery(query))) {
 /**
 * @type {{removed: !Array., events: !Array.}}
 */
 var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
 if (maybeSyncPoint.isEmpty()) {
 this.syncPointTree_ = this.syncPointTree_.remove(path);
 }
 var removed = removedAndEvents.removed;
 cancelEvents = removedAndEvents.events;
 // We may have just removed one of many listeners and can short-circuit this whole process
 // We may also not have removed a default listener, in which case all of the descendant listeners should already be
 // properly set up.
 //
 // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
 // queryId === 'default'
 var removingDefault = -1 !==
 removed.findIndex(function (query) {
 return query.getQueryParams().loadsAllData();
 });
 var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
 return parentSyncPoint.hasCompleteView();
 });
 if (removingDefault && !covered) {
 var subtree = this.syncPointTree_.subtree(path);
 // There are potentially child listeners. Determine what if any listens we need to send before executing the
 // removal
 if (!subtree.isEmpty()) {
 // We need to fold over our subtree and collect the listeners to send
 var newViews = this.collectDistinctViewsForSubTree_(subtree);
 // Ok, we've collected all the listens we need. Set them up.
 for (var i = 0; i < newViews.length; ++i) {
 var view = newViews[i], newQuery = view.getQuery();
 var listener = this.createListenerForView_(view);
 this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
 }
 }
 else {
 // There's nothing below us, so nothing we need to start listening on
 }
 }
 // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
 // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
 // Also, note that if we have a cancelError, it's already been removed at the provider level.
 if (!covered && removed.length > 0 && !cancelError) {
 // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
 // default. Otherwise, we need to iterate through and cancel each individual query
 if (removingDefault) {
 // We don't tag default listeners
 var defaultTag = null;
 this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
 }
 else {
 removed.forEach(function (queryToRemove) {
 var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
 _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
 });
 }
 }
 // Now, clear all of the tags we're tracking for the removed listens
 this.removeTags_(removed);
 }
 else {
 // No-op, this listener must've been already removed
 }
 return cancelEvents;
 };
 /**
 * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
 * it, but as this is only used by transaction code, that should always be the case anyways.
 *
 * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
 * @param {!Path} path The path to the data we want
 * @param {Array.=} writeIdsToExclude A specific set to be excluded
 * @return {?Node}
 */
 SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
 var includeHiddenSets = true;
 var writeTree = this.pendingWriteTree_;
 var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
 var relativePath = Path_1.Path.relativePath(pathSoFar, path);
 var serverCache = syncPoint.getCompleteServerCache(relativePath);
 if (serverCache) {
 return serverCache;
 }
 });
 return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
 };
 /**
 * This collapses multiple unfiltered views into a single view, since we only need a single
 * listener for them.
 *
 * @param {!ImmutableTree.} subtree
 * @return {!Array.}
 * @private
 */
 SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
 return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
 if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
 var completeView = maybeChildSyncPoint.getCompleteView();
 return [completeView];
 }
 else {
 // No complete view here, flatten any deeper listens into an array
 var views_1 = [];
 if (maybeChildSyncPoint) {
 views_1 = maybeChildSyncPoint.getQueryViews();
 }
 util_3.forEach(childMap, function (key, childViews) {
 views_1 = views_1.concat(childViews);
 });
 return views_1;
 }
 });
 };
 /**
 * @param {!Array.} queries
 * @private
 */
 SyncTree.prototype.removeTags_ = function (queries) {
 for (var j = 0; j < queries.length; ++j) {
 var removedQuery = queries[j];
 if (!removedQuery.getQueryParams().loadsAllData()) {
 // We should have a tag for this
 var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
 var removedQueryTag = this.queryToTagMap_[removedQueryKey];
 delete this.queryToTagMap_[removedQueryKey];
 delete this.tagToQueryMap_['_' + removedQueryTag];
 }
 }
 };
 /**
 * Normalizes a query to a query we send the server for listening
 * @param {!Query} query
 * @return {!Query} The normalized query
 * @private
 */
 SyncTree.queryForListening_ = function (query) {
 if (query.getQueryParams().loadsAllData() &&
 !query.getQueryParams().isDefault()) {
 // We treat queries that load all data as default queries
 // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
 // from Query
 return /** @type {!Query} */ query.getRef();
 }
 else {
 return query;
 }
 };
 /**
 * For a given new listen, manage the de-duplication of outstanding subscriptions.
 *
 * @param {!Query} query
 * @param {!View} view
 * @return {!Array.} This method can return events to support synchronous data sources
 * @private
 */
 SyncTree.prototype.setupListener_ = function (query, view) {
 var path = query.path;
 var tag = this.tagForQuery_(query);
 var listener = this.createListenerForView_(view);
 var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
 var subtree = this.syncPointTree_.subtree(path);
 // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
 // may need to shadow other listens as well.
 if (tag) {
 util_1.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
 }
 else {
 // Shadow everything at or below this location, this is a default listener.
 var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
 if (!relativePath.isEmpty() &&
 maybeChildSyncPoint &&
 maybeChildSyncPoint.hasCompleteView()) {
 return [maybeChildSyncPoint.getCompleteView().getQuery()];
 }
 else {
 // No default listener here, flatten any deeper queries into an array
 var queries_1 = [];
 if (maybeChildSyncPoint) {
 queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
 }
 util_3.forEach(childMap, function (key, childQueries) {
 queries_1 = queries_1.concat(childQueries);
 });
 return queries_1;
 }
 });
 for (var i = 0; i < queriesToStop.length; ++i) {
 var queryToStop = queriesToStop[i];
 this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
 }
 }
 return events;
 };
 /**
 *
 * @param {!View} view
 * @return {{hashFn: function(), onComplete: function(!string, *)}}
 * @private
 */
 SyncTree.prototype.createListenerForView_ = function (view) {
 var _this = this;
 var query = view.getQuery();
 var tag = this.tagForQuery_(query);
 return {
 hashFn: function () {
 var cache = view.getServerCache() || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 return cache.hash();
 },
 onComplete: function (status) {
 if (status === 'ok') {
 if (tag) {
 return _this.applyTaggedListenComplete(query.path, tag);
 }
 else {
 return _this.applyListenComplete(query.path);
 }
 }
 else {
 // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
 // Note that this may need to be scoped to just this listener if we change permissions on filtered children
 var error = util_2.errorForServerCode(status, query);
 return _this.removeEventRegistration(query, 
 /*eventRegistration*/ null, error);
 }
 }
 };
 };
 /**
 * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
 * @private
 * @param {!Query} query
 * @return {string}
 */
 SyncTree.makeQueryKey_ = function (query) {
 return query.path.toString() + '$' + query.queryIdentifier();
 };
 /**
 * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
 * @private
 * @param {!string} queryKey
 * @return {{queryId: !string, path: !Path}}
 */
 SyncTree.parseQueryKey_ = function (queryKey) {
 var splitIndex = queryKey.indexOf('$');
 util_1.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
 return {
 queryId: queryKey.substr(splitIndex + 1),
 path: new Path_1.Path(queryKey.substr(0, splitIndex))
 };
 };
 /**
 * Return the query associated with the given tag, if we have one
 * @param {!number} tag
 * @return {?string}
 * @private
 */
 SyncTree.prototype.queryKeyForTag_ = function (tag) {
 return this.tagToQueryMap_['_' + tag];
 };
 /**
 * Return the tag associated with the given query.
 * @param {!Query} query
 * @return {?number}
 * @private
 */
 SyncTree.prototype.tagForQuery_ = function (query) {
 var queryKey = SyncTree.makeQueryKey_(query);
 return util_3.safeGet(this.queryToTagMap_, queryKey);
 };
 /**
 * Static accessor for query tags.
 * @return {number}
 * @private
 */
 SyncTree.getNextQueryTag_ = function () {
 return SyncTree.nextQueryTag_++;
 };
 /**
 * A helper method to apply tagged operations
 *
 * @param {!Path} queryPath
 * @param {!Operation} operation
 * @return {!Array.}
 * @private
 */
 SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
 var syncPoint = this.syncPointTree_.get(queryPath);
 util_1.assert(syncPoint, "Missing sync point for query tag that we're tracking");
 var writesCache = this.pendingWriteTree_.childWrites(queryPath);
 return syncPoint.applyOperation(operation, writesCache, 
 /*serverCache=*/ null);
 };
 /**
 * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
 *
 * NOTES:
 * - Descendant SyncPoints will be visited first (since we raise events depth-first).
 
 * - We call applyOperation() on each SyncPoint passing three things:
 * 1. A version of the Operation that has been made relative to the SyncPoint location.
 * 2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
 * 3. A snapshot Node with cached server data, if we have it.
 
 * - We concatenate all of the events returned by each SyncPoint and return the result.
 *
 * @param {!Operation} operation
 * @return {!Array.}
 * @private
 */
 SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
 return this.applyOperationHelper_(operation, this.syncPointTree_, 
 /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path_1.Path.Empty));
 };
 /**
 * Recursive helper for applyOperationToSyncPoints_
 *
 * @private
 * @param {!Operation} operation
 * @param {ImmutableTree.} syncPointTree
 * @param {?Node} serverCache
 * @param {!WriteTreeRef} writesCache
 * @return {!Array.}
 */
 SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
 if (operation.path.isEmpty()) {
 return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
 }
 else {
 var syncPoint = syncPointTree.get(Path_1.Path.Empty);
 // If we don't have cached server data, see if we can get it from this SyncPoint.
 if (serverCache == null && syncPoint != null) {
 serverCache = syncPoint.getCompleteServerCache(Path_1.Path.Empty);
 }
 var events = [];
 var childName = operation.path.getFront();
 var childOperation = operation.operationForChild(childName);
 var childTree = syncPointTree.children.get(childName);
 if (childTree && childOperation) {
 var childServerCache = serverCache
 ? serverCache.getImmediateChild(childName)
 : null;
 var childWritesCache = writesCache.child(childName);
 events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
 }
 if (syncPoint) {
 events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
 }
 return events;
 }
 };
 /**
 * Recursive helper for applyOperationToSyncPoints_
 *
 * @private
 * @param {!Operation} operation
 * @param {ImmutableTree.} syncPointTree
 * @param {?Node} serverCache
 * @param {!WriteTreeRef} writesCache
 * @return {!Array.}
 */
 SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
 var _this = this;
 var syncPoint = syncPointTree.get(Path_1.Path.Empty);
 // If we don't have cached server data, see if we can get it from this SyncPoint.
 if (serverCache == null && syncPoint != null) {
 serverCache = syncPoint.getCompleteServerCache(Path_1.Path.Empty);
 }
 var events = [];
 syncPointTree.children.inorderTraversal(function (childName, childTree) {
 var childServerCache = serverCache
 ? serverCache.getImmediateChild(childName)
 : null;
 var childWritesCache = writesCache.child(childName);
 var childOperation = operation.operationForChild(childName);
 if (childOperation) {
 events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
 }
 });
 if (syncPoint) {
 events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
 }
 return events;
 };
 /**
 * Static tracker for next query tag.
 * @type {number}
 * @private
 */
 SyncTree.nextQueryTag_ = 1;
 return SyncTree;
}());
exports.SyncTree = SyncTree;

//# sourceMappingURL=SyncTree.js.map


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var Path_1 = __webpack_require__(2);
var Operation_1 = __webpack_require__(8);
var AckUserWrite = /** @class */ (function () {
 /**
 *
 * @param {!Path} path
 * @param {!ImmutableTree} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
 * @param {!boolean} revert
 */
 function AckUserWrite(
 /**@inheritDoc */ path, 
 /**@inheritDoc */ affectedTree, 
 /**@inheritDoc */ revert) {
 this.path = path;
 this.affectedTree = affectedTree;
 this.revert = revert;
 /** @inheritDoc */
 this.type = Operation_1.OperationType.ACK_USER_WRITE;
 /** @inheritDoc */
 this.source = Operation_1.OperationSource.User;
 }
 /**
 * @inheritDoc
 */
 AckUserWrite.prototype.operationForChild = function (childName) {
 if (!this.path.isEmpty()) {
 util_1.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
 return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
 }
 else if (this.affectedTree.value != null) {
 util_1.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
 // All child locations are affected as well; just return same operation.
 return this;
 }
 else {
 var childTree = this.affectedTree.subtree(new Path_1.Path(childName));
 return new AckUserWrite(Path_1.Path.Empty, childTree, this.revert);
 }
 };
 return AckUserWrite;
}());
exports.AckUserWrite = AckUserWrite;

//# sourceMappingURL=AckUserWrite.js.map


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Path_1 = __webpack_require__(2);
var Operation_1 = __webpack_require__(8);
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
 function ListenComplete(source, path) {
 this.source = source;
 this.path = path;
 /** @inheritDoc */
 this.type = Operation_1.OperationType.LISTEN_COMPLETE;
 }
 ListenComplete.prototype.operationForChild = function (childName) {
 if (this.path.isEmpty()) {
 return new ListenComplete(this.source, Path_1.Path.Empty);
 }
 else {
 return new ListenComplete(this.source, this.path.popFront());
 }
 };
 return ListenComplete;
}());
exports.ListenComplete = ListenComplete;

//# sourceMappingURL=ListenComplete.js.map


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Operation_1 = __webpack_require__(8);
var Overwrite_1 = __webpack_require__(46);
var Path_1 = __webpack_require__(2);
var util_1 = __webpack_require__(0);
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
 function Merge(
 /**@inheritDoc */ source, 
 /**@inheritDoc */ path, 
 /**@inheritDoc */ children) {
 this.source = source;
 this.path = path;
 this.children = children;
 /** @inheritDoc */
 this.type = Operation_1.OperationType.MERGE;
 }
 /**
 * @inheritDoc
 */
 Merge.prototype.operationForChild = function (childName) {
 if (this.path.isEmpty()) {
 var childTree = this.children.subtree(new Path_1.Path(childName));
 if (childTree.isEmpty()) {
 // This child is unaffected
 return null;
 }
 else if (childTree.value) {
 // We have a snapshot for the child in question. This becomes an overwrite of the child.
 return new Overwrite_1.Overwrite(this.source, Path_1.Path.Empty, childTree.value);
 }
 else {
 // This is a merge at a deeper level
 return new Merge(this.source, Path_1.Path.Empty, childTree);
 }
 }
 else {
 util_1.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
 return new Merge(this.source, this.path.popFront(), this.children);
 }
 };
 /**
 * @inheritDoc
 */
 Merge.prototype.toString = function () {
 return ('Operation(' +
 this.path +
 ': ' +
 this.source.toString() +
 ' merge: ' +
 this.children.toString() +
 ')');
 };
 return Merge;
}());
exports.Merge = Merge;

//# sourceMappingURL=Merge.js.map


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedFilter_1 = __webpack_require__(24);
var ViewProcessor_1 = __webpack_require__(91);
var ChildrenNode_1 = __webpack_require__(4);
var CacheNode_1 = __webpack_require__(18);
var ViewCache_1 = __webpack_require__(48);
var EventGenerator_1 = __webpack_require__(94);
var util_1 = __webpack_require__(0);
var Operation_1 = __webpack_require__(8);
var Change_1 = __webpack_require__(9);
var PriorityIndex_1 = __webpack_require__(3);
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 * - Maintains the list of event registrations for this location/query.
 * - Maintains a cache of the data visible for this location/query.
 * - Applies new operations (via applyOperation), updates the cache, and based on the event
 * registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
 /**
 *
 * @param {!Query} query_
 * @param {!ViewCache} initialViewCache
 */
 function View(query_, initialViewCache) {
 this.query_ = query_;
 this.eventRegistrations_ = [];
 var params = this.query_.getQueryParams();
 var indexFilter = new IndexedFilter_1.IndexedFilter(params.getIndex());
 var filter = params.getNodeFilter();
 /**
 * @type {ViewProcessor}
 * @private
 */
 this.processor_ = new ViewProcessor_1.ViewProcessor(filter);
 var initialServerCache = initialViewCache.getServerCache();
 var initialEventCache = initialViewCache.getEventCache();
 // Don't filter server node with other filter than index, wait for tagged listen
 var serverSnap = indexFilter.updateFullNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
 var eventSnap = filter.updateFullNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
 var newServerCache = new CacheNode_1.CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
 var newEventCache = new CacheNode_1.CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
 /**
 * @type {!ViewCache}
 * @private
 */
 this.viewCache_ = new ViewCache_1.ViewCache(newEventCache, newServerCache);
 /**
 * @type {!EventGenerator}
 * @private
 */
 this.eventGenerator_ = new EventGenerator_1.EventGenerator(this.query_);
 }
 /**
 * @return {!Query}
 */
 View.prototype.getQuery = function () {
 return this.query_;
 };
 /**
 * @return {?Node}
 */
 View.prototype.getServerCache = function () {
 return this.viewCache_.getServerCache().getNode();
 };
 /**
 * @param {!Path} path
 * @return {?Node}
 */
 View.prototype.getCompleteServerCache = function (path) {
 var cache = this.viewCache_.getCompleteServerSnap();
 if (cache) {
 // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
 // we need to see if it contains the child we're interested in.
 if (this.query_.getQueryParams().loadsAllData() ||
 (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
 return cache.getChild(path);
 }
 }
 return null;
 };
 /**
 * @return {boolean}
 */
 View.prototype.isEmpty = function () {
 return this.eventRegistrations_.length === 0;
 };
 /**
 * @param {!EventRegistration} eventRegistration
 */
 View.prototype.addEventRegistration = function (eventRegistration) {
 this.eventRegistrations_.push(eventRegistration);
 };
 /**
 * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
 * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
 * @return {!Array.} Cancel events, if cancelError was provided.
 */
 View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
 var cancelEvents = [];
 if (cancelError) {
 util_1.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
 var path_1 = this.query_.path;
 this.eventRegistrations_.forEach(function (registration) {
 cancelError /** @type {!Error} */ = cancelError;
 var maybeEvent = registration.createCancelEvent(cancelError, path_1);
 if (maybeEvent) {
 cancelEvents.push(maybeEvent);
 }
 });
 }
 if (eventRegistration) {
 var remaining = [];
 for (var i = 0; i < this.eventRegistrations_.length; ++i) {
 var existing = this.eventRegistrations_[i];
 if (!existing.matches(eventRegistration)) {
 remaining.push(existing);
 }
 else if (eventRegistration.hasAnyCallback()) {
 // We're removing just this one
 remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
 break;
 }
 }
 this.eventRegistrations_ = remaining;
 }
 else {
 this.eventRegistrations_ = [];
 }
 return cancelEvents;
 };
 /**
 * Applies the given Operation, updates our cache, and returns the appropriate events.
 *
 * @param {!Operation} operation
 * @param {!WriteTreeRef} writesCache
 * @param {?Node} completeServerCache
 * @return {!Array.}
 */
 View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
 if (operation.type === Operation_1.OperationType.MERGE &&
 operation.source.queryId !== null) {
 util_1.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
 util_1.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
 }
 var oldViewCache = this.viewCache_;
 var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
 this.processor_.assertIndexed(result.viewCache);
 util_1.assert(result.viewCache.getServerCache().isFullyInitialized() ||
 !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
 this.viewCache_ = result.viewCache;
 return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
 };
 /**
 * @param {!EventRegistration} registration
 * @return {!Array.}
 */
 View.prototype.getInitialEvents = function (registration) {
 var eventSnap = this.viewCache_.getEventCache();
 var initialChanges = [];
 if (!eventSnap.getNode().isLeafNode()) {
 var eventNode = eventSnap.getNode();
 eventNode.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
 initialChanges.push(Change_1.Change.childAddedChange(key, childNode));
 });
 }
 if (eventSnap.isFullyInitialized()) {
 initialChanges.push(Change_1.Change.valueChange(eventSnap.getNode()));
 }
 return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
 };
 /**
 * @private
 * @param {!Array.} changes
 * @param {!Node} eventCache
 * @param {EventRegistration=} eventRegistration
 * @return {!Array.}
 */
 View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
 var registrations = eventRegistration
 ? [eventRegistration]
 : this.eventRegistrations_;
 return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
 };
 return View;
}());
exports.View = View;

//# sourceMappingURL=View.js.map


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Operation_1 = __webpack_require__(8);
var util_1 = __webpack_require__(0);
var ChildChangeAccumulator_1 = __webpack_require__(92);
var Change_1 = __webpack_require__(9);
var ChildrenNode_1 = __webpack_require__(4);
var KeyIndex_1 = __webpack_require__(10);
var ImmutableTree_1 = __webpack_require__(23);
var Path_1 = __webpack_require__(2);
var CompleteChildSource_1 = __webpack_require__(93);
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
 /**
 * @param {!ViewCache} viewCache
 * @param {!Array.} changes
 */
 function ProcessorResult(viewCache, changes) {
 this.viewCache = viewCache;
 this.changes = changes;
 }
 return ProcessorResult;
}());
exports.ProcessorResult = ProcessorResult;
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
 /**
 * @param {!NodeFilter} filter_
 */
 function ViewProcessor(filter_) {
 this.filter_ = filter_;
 }
 /**
 * @param {!ViewCache} viewCache
 */
 ViewProcessor.prototype.assertIndexed = function (viewCache) {
 util_1.assert(viewCache
 .getEventCache()
 .getNode()
 .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
 util_1.assert(viewCache
 .getServerCache()
 .getNode()
 .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
 };
 /**
 * @param {!ViewCache} oldViewCache
 * @param {!Operation} operation
 * @param {!WriteTreeRef} writesCache
 * @param {?Node} completeCache
 * @return {!ProcessorResult}
 */
 ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
 var accumulator = new ChildChangeAccumulator_1.ChildChangeAccumulator();
 var newViewCache, filterServerNode;
 if (operation.type === Operation_1.OperationType.OVERWRITE) {
 var overwrite = operation;
 if (overwrite.source.fromUser) {
 newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
 }
 else {
 util_1.assert(overwrite.source.fromServer, 'Unknown source.');
 // We filter the node if it's a tagged update or the node has been previously filtered and the
 // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
 // again
 filterServerNode =
 overwrite.source.tagged ||
 (oldViewCache.getServerCache().isFiltered() &&
 !overwrite.path.isEmpty());
 newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
 }
 }
 else if (operation.type === Operation_1.OperationType.MERGE) {
 var merge = operation;
 if (merge.source.fromUser) {
 newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
 }
 else {
 util_1.assert(merge.source.fromServer, 'Unknown source.');
 // We filter the node if it's a tagged update or the node has been previously filtered
 filterServerNode =
 merge.source.tagged || oldViewCache.getServerCache().isFiltered();
 newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
 }
 }
 else if (operation.type === Operation_1.OperationType.ACK_USER_WRITE) {
 var ackUserWrite = operation;
 if (!ackUserWrite.revert) {
 newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
 }
 else {
 newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
 }
 }
 else if (operation.type === Operation_1.OperationType.LISTEN_COMPLETE) {
 newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
 }
 else {
 throw util_1.assertionError('Unknown operation type: ' + operation.type);
 }
 var changes = accumulator.getChanges();
 ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
 return new ProcessorResult(newViewCache, changes);
 };
 /**
 * @param {!ViewCache} oldViewCache
 * @param {!ViewCache} newViewCache
 * @param {!Array.} accumulator
 * @private
 */
 ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
 var eventSnap = newViewCache.getEventCache();
 if (eventSnap.isFullyInitialized()) {
 var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
 var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
 if (accumulator.length > 0 ||
 !oldViewCache.getEventCache().isFullyInitialized() ||
 (isLeafOrEmpty &&
 !eventSnap
 .getNode()
 .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
 !eventSnap
 .getNode()
 .getPriority()
 .equals(oldCompleteSnap.getPriority())) {
 accumulator.push(Change_1.Change.valueChange(
 /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
 }
 }
 };
 /**
 * @param {!ViewCache} viewCache
 * @param {!Path} changePath
 * @param {!WriteTreeRef} writesCache
 * @param {!CompleteChildSource} source
 * @param {!ChildChangeAccumulator} accumulator
 * @return {!ViewCache}
 * @private
 */
 ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
 var oldEventSnap = viewCache.getEventCache();
 if (writesCache.shadowingWrite(changePath) != null) {
 // we have a shadowing write, ignore changes
 return viewCache;
 }
 else {
 var newEventCache = void 0, serverNode = void 0;
 if (changePath.isEmpty()) {
 // TODO: figure out how this plays with "sliding ack windows"
 util_1.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
 if (viewCache.getServerCache().isFiltered()) {
 // We need to special case this, because we need to only apply writes to complete children, or
 // we might end up raising events for incomplete children. If the server data is filtered deep
 // writes cannot be guaranteed to be complete
 var serverCache = viewCache.getCompleteServerSnap();
 var completeChildren = serverCache instanceof ChildrenNode_1.ChildrenNode
 ? serverCache
 : ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
 newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
 }
 else {
 var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
 newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
 }
 }
 else {
 var childKey = changePath.getFront();
 if (childKey == '.priority') {
 util_1.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
 var oldEventNode = oldEventSnap.getNode();
 serverNode = viewCache.getServerCache().getNode();
 // we might have overwrites for this priority
 var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
 if (updatedPriority != null) {
 newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
 }
 else {
 // priority didn't change, keep old node
 newEventCache = oldEventSnap.getNode();
 }
 }
 else {
 var childChangePath = changePath.popFront();
 // update child
 var newEventChild = void 0;
 if (oldEventSnap.isCompleteForChild(childKey)) {
 serverNode = viewCache.getServerCache().getNode();
 var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
 if (eventChildUpdate != null) {
 newEventChild = oldEventSnap
 .getNode()
 .getImmediateChild(childKey)
 .updateChild(childChangePath, eventChildUpdate);
 }
 else {
 // Nothing changed, just keep the old child
 newEventChild = oldEventSnap
 .getNode()
 .getImmediateChild(childKey);
 }
 }
 else {
 newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
 }
 if (newEventChild != null) {
 newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
 }
 else {
 // no complete child available or no change
 newEventCache = oldEventSnap.getNode();
 }
 }
 }
 return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
 }
 };
 /**
 * @param {!ViewCache} oldViewCache
 * @param {!Path} changePath
 * @param {!Node} changedSnap
 * @param {!WriteTreeRef} writesCache
 * @param {?Node} completeCache
 * @param {boolean} filterServerNode
 * @param {!ChildChangeAccumulator} accumulator
 * @return {!ViewCache}
 * @private
 */
 ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
 var oldServerSnap = oldViewCache.getServerCache();
 var newServerCache;
 var serverFilter = filterServerNode
 ? this.filter_
 : this.filter_.getIndexedFilter();
 if (changePath.isEmpty()) {
 newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
 }
 else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
 // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
 var newServerNode = oldServerSnap
 .getNode()
 .updateChild(changePath, changedSnap);
 newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
 }
 else {
 var childKey = changePath.getFront();
 if (!oldServerSnap.isCompleteForPath(changePath) &&
 changePath.getLength() > 1) {
 // We don't update incomplete nodes with updates intended for other listeners
 return oldViewCache;
 }
 var childChangePath = changePath.popFront();
 var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
 var newChildNode = childNode.updateChild(childChangePath, changedSnap);
 if (childKey == '.priority') {
 newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
 }
 else {
 newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, CompleteChildSource_1.NO_COMPLETE_CHILD_SOURCE, null);
 }
 }
 var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
 var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
 return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
 };
 /**
 * @param {!ViewCache} oldViewCache
 * @param {!Path} changePath
 * @param {!Node} changedSnap
 * @param {!WriteTreeRef} writesCache
 * @param {?Node} completeCache
 * @param {!ChildChangeAccumulator} accumulator
 * @return {!ViewCache}
 * @private
 */
 ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
 var oldEventSnap = oldViewCache.getEventCache();
 var newViewCache, newEventCache;
 var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
 if (changePath.isEmpty()) {
 newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
 newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
 }
 else {
 var childKey = changePath.getFront();
 if (childKey === '.priority') {
 newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
 newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
 }
 else {
 var childChangePath = changePath.popFront();
 var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
 var newChild = void 0;
 if (childChangePath.isEmpty()) {
 // Child overwrite, we can replace the child
 newChild = changedSnap;
 }
 else {
 var childNode = source.getCompleteChild(childKey);
 if (childNode != null) {
 if (childChangePath.getBack() === '.priority' &&
 childNode.getChild(childChangePath.parent()).isEmpty()) {
 // This is a priority update on an empty node. If this node exists on the server, the
 // server will send down the priority in the update, so ignore for now
 newChild = childNode;
 }
 else {
 newChild = childNode.updateChild(childChangePath, changedSnap);
 }
 }
 else {
 // There is no complete child node available
 newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 }
 }
 if (!oldChild.equals(newChild)) {
 var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
 newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
 }
 else {
 newViewCache = oldViewCache;
 }
 }
 }
 return newViewCache;
 };
 /**
 * @param {!ViewCache} viewCache
 * @param {string} childKey
 * @return {boolean}
 * @private
 */
 ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
 return viewCache.getEventCache().isCompleteForChild(childKey);
 };
 /**
 * @param {!ViewCache} viewCache
 * @param {!Path} path
 * @param {ImmutableTree.} changedChildren
 * @param {!WriteTreeRef} writesCache
 * @param {?Node} serverCache
 * @param {!ChildChangeAccumulator} accumulator
 * @return {!ViewCache}
 * @private
 */
 ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
 var _this = this;
 // HACK: In the case of a limit query, there may be some changes that bump things out of the
 // window leaving room for new items. It's important we process these changes first, so we
 // iterate the changes twice, first processing any that affect items currently in view.
 // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
 // and event snap. I'm not sure if this will result in edge cases when a child is in one but
 // not the other.
 var curViewCache = viewCache;
 changedChildren.foreach(function (relativePath, childNode) {
 var writePath = path.child(relativePath);
 if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
 curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
 }
 });
 changedChildren.foreach(function (relativePath, childNode) {
 var writePath = path.child(relativePath);
 if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
 curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
 }
 });
 return curViewCache;
 };
 /**
 * @param {!Node} node
 * @param {ImmutableTree.} merge
 * @return {!Node}
 * @private
 */
 ViewProcessor.prototype.applyMerge_ = function (node, merge) {
 merge.foreach(function (relativePath, childNode) {
 node = node.updateChild(relativePath, childNode);
 });
 return node;
 };
 /**
 * @param {!ViewCache} viewCache
 * @param {!Path} path
 * @param {!ImmutableTree.} changedChildren
 * @param {!WriteTreeRef} writesCache
 * @param {?Node} serverCache
 * @param {boolean} filterServerNode
 * @param {!ChildChangeAccumulator} accumulator
 * @return {!ViewCache}
 * @private
 */
 ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
 var _this = this;
 // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
 // wait for the complete data update coming soon.
 if (viewCache
 .getServerCache()
 .getNode()
 .isEmpty() &&
 !viewCache.getServerCache().isFullyInitialized()) {
 return viewCache;
 }
 // HACK: In the case of a limit query, there may be some changes that bump things out of the
 // window leaving room for new items. It's important we process these changes first, so we
 // iterate the changes twice, first processing any that affect items currently in view.
 // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
 // and event snap. I'm not sure if this will result in edge cases when a child is in one but
 // not the other.
 var curViewCache = viewCache;
 var viewMergeTree;
 if (path.isEmpty()) {
 viewMergeTree = changedChildren;
 }
 else {
 viewMergeTree = ImmutableTree_1.ImmutableTree.Empty.setTree(path, changedChildren);
 }
 var serverNode = viewCache.getServerCache().getNode();
 viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
 if (serverNode.hasChild(childKey)) {
 var serverChild = viewCache
 .getServerCache()
 .getNode()
 .getImmediateChild(childKey);
 var newChild = _this.applyMerge_(serverChild, childTree);
 curViewCache = _this.applyServerOverwrite_(curViewCache, new Path_1.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
 }
 });
 viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
 var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
 childMergeTree.value == null;
 if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
 var serverChild = viewCache
 .getServerCache()
 .getNode()
 .getImmediateChild(childKey);
 var newChild = _this.applyMerge_(serverChild, childMergeTree);
 curViewCache = _this.applyServerOverwrite_(curViewCache, new Path_1.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
 }
 });
 return curViewCache;
 };
 /**
 * @param {!ViewCache} viewCache
 * @param {!Path} ackPath
 * @param {!ImmutableTree} affectedTree
 * @param {!WriteTreeRef} writesCache
 * @param {?Node} completeCache
 * @param {!ChildChangeAccumulator} accumulator
 * @return {!ViewCache}
 * @private
 */
 ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
 if (writesCache.shadowingWrite(ackPath) != null) {
 return viewCache;
 }
 // Only filter server node if it is currently filtered
 var filterServerNode = viewCache.getServerCache().isFiltered();
 // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
 // now that it won't be shadowed.
 var serverCache = viewCache.getServerCache();
 if (affectedTree.value != null) {
 // This is an overwrite.
 if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
 serverCache.isCompleteForPath(ackPath)) {
 return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
 }
 else if (ackPath.isEmpty()) {
 // This is a goofy edge case where we are acking data at this location but don't have full data. We
 // should just re-apply whatever we have in our cache as a merge.
 var changedChildren_1 = ImmutableTree_1.ImmutableTree.Empty;
 serverCache.getNode().forEachChild(KeyIndex_1.KEY_INDEX, function (name, node) {
 changedChildren_1 = changedChildren_1.set(new Path_1.Path(name), node);
 });
 return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
 }
 else {
 return viewCache;
 }
 }
 else {
 // This is a merge.
 var changedChildren_2 = ImmutableTree_1.ImmutableTree.Empty;
 affectedTree.foreach(function (mergePath, value) {
 var serverCachePath = ackPath.child(mergePath);
 if (serverCache.isCompleteForPath(serverCachePath)) {
 changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
 }
 });
 return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
 }
 };
 /**
 * @param {!ViewCache} viewCache
 * @param {!Path} path
 * @param {!WriteTreeRef} writesCache
 * @param {!ChildChangeAccumulator} accumulator
 * @return {!ViewCache}
 * @private
 */
 ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
 var oldServerNode = viewCache.getServerCache();
 var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
 return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, CompleteChildSource_1.NO_COMPLETE_CHILD_SOURCE, accumulator);
 };
 /**
 * @param {!ViewCache} viewCache
 * @param {!Path} path
 * @param {!WriteTreeRef} writesCache
 * @param {?Node} completeServerCache
 * @param {!ChildChangeAccumulator} accumulator
 * @return {!ViewCache}
 * @private
 */
 ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
 var complete;
 if (writesCache.shadowingWrite(path) != null) {
 return viewCache;
 }
 else {
 var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
 var oldEventCache = viewCache.getEventCache().getNode();
 var newEventCache = void 0;
 if (path.isEmpty() || path.getFront() === '.priority') {
 var newNode = void 0;
 if (viewCache.getServerCache().isFullyInitialized()) {
 newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
 }
 else {
 var serverChildren = viewCache.getServerCache().getNode();
 util_1.assert(serverChildren instanceof ChildrenNode_1.ChildrenNode, 'serverChildren would be complete if leaf node');
 newNode = writesCache.calcCompleteEventChildren(serverChildren);
 }
 newNode = newNode;
 newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
 }
 else {
 var childKey = path.getFront();
 var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
 if (newChild == null &&
 viewCache.getServerCache().isCompleteForChild(childKey)) {
 newChild = oldEventCache.getImmediateChild(childKey);
 }
 if (newChild != null) {
 newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
 }
 else if (viewCache
 .getEventCache()
 .getNode()
 .hasChild(childKey)) {
 // No complete child available, delete the existing one, if any
 newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode_1.ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
 }
 else {
 newEventCache = oldEventCache;
 }
 if (newEventCache.isEmpty() &&
 viewCache.getServerCache().isFullyInitialized()) {
 // We might have reverted all child writes. Maybe the old event was a leaf node
 complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
 if (complete.isLeafNode()) {
 newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
 }
 }
 }
 complete =
 viewCache.getServerCache().isFullyInitialized() ||
 writesCache.shadowingWrite(Path_1.Path.Empty) != null;
 return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
 }
 };
 return ViewProcessor;
}());
exports.ViewProcessor = ViewProcessor;

//# sourceMappingURL=ViewProcessor.js.map


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var Change_1 = __webpack_require__(9);
var util_2 = __webpack_require__(0);
/**
 * @constructor
 */
var ChildChangeAccumulator = /** @class */ (function () {
 function ChildChangeAccumulator() {
 this.changeMap_ = {};
 }
 /**
 * @param {!Change} change
 */
 ChildChangeAccumulator.prototype.trackChildChange = function (change) {
 var type = change.type;
 var childKey /** @type {!string} */ = change.childName;
 util_2.assert(type == Change_1.Change.CHILD_ADDED ||
 type == Change_1.Change.CHILD_CHANGED ||
 type == Change_1.Change.CHILD_REMOVED, 'Only child changes supported for tracking');
 util_2.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
 var oldChange = util_1.safeGet(this.changeMap_, childKey);
 if (oldChange) {
 var oldType = oldChange.type;
 if (type == Change_1.Change.CHILD_ADDED && oldType == Change_1.Change.CHILD_REMOVED) {
 this.changeMap_[childKey] = Change_1.Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
 }
 else if (type == Change_1.Change.CHILD_REMOVED &&
 oldType == Change_1.Change.CHILD_ADDED) {
 delete this.changeMap_[childKey];
 }
 else if (type == Change_1.Change.CHILD_REMOVED &&
 oldType == Change_1.Change.CHILD_CHANGED) {
 this.changeMap_[childKey] = Change_1.Change.childRemovedChange(childKey, oldChange.oldSnap);
 }
 else if (type == Change_1.Change.CHILD_CHANGED &&
 oldType == Change_1.Change.CHILD_ADDED) {
 this.changeMap_[childKey] = Change_1.Change.childAddedChange(childKey, change.snapshotNode);
 }
 else if (type == Change_1.Change.CHILD_CHANGED &&
 oldType == Change_1.Change.CHILD_CHANGED) {
 this.changeMap_[childKey] = Change_1.Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
 }
 else {
 throw util_2.assertionError('Illegal combination of changes: ' +
 change +
 ' occurred after ' +
 oldChange);
 }
 }
 else {
 this.changeMap_[childKey] = change;
 }
 };
 /**
 * @return {!Array.}
 */
 ChildChangeAccumulator.prototype.getChanges = function () {
 return util_1.getValues(this.changeMap_);
 };
 return ChildChangeAccumulator;
}());
exports.ChildChangeAccumulator = ChildChangeAccumulator;

//# sourceMappingURL=ChildChangeAccumulator.js.map


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var CacheNode_1 = __webpack_require__(18);
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
 function NoCompleteChildSource_() {
 }
 /**
 * @inheritDoc
 */
 NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
 return null;
 };
 /**
 * @inheritDoc
 */
 NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
 return null;
 };
 return NoCompleteChildSource_;
}());
exports.NoCompleteChildSource_ = NoCompleteChildSource_;
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
exports.NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
 /**
 * @param {!WriteTreeRef} writes_
 * @param {!ViewCache} viewCache_
 * @param {?Node} optCompleteServerCache_
 */
 function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
 if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
 this.writes_ = writes_;
 this.viewCache_ = viewCache_;
 this.optCompleteServerCache_ = optCompleteServerCache_;
 }
 /**
 * @inheritDoc
 */
 WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
 var node = this.viewCache_.getEventCache();
 if (node.isCompleteForChild(childKey)) {
 return node.getNode().getImmediateChild(childKey);
 }
 else {
 var serverNode = this.optCompleteServerCache_ != null
 ? new CacheNode_1.CacheNode(this.optCompleteServerCache_, true, false)
 : this.viewCache_.getServerCache();
 return this.writes_.calcCompleteChild(childKey, serverNode);
 }
 };
 /**
 * @inheritDoc
 */
 WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
 var completeServerData = this.optCompleteServerCache_ != null
 ? this.optCompleteServerCache_
 : this.viewCache_.getCompleteServerSnap();
 var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
 if (nodes.length === 0) {
 return null;
 }
 else {
 return nodes[0];
 }
 };
 return WriteTreeCompleteChildSource;
}());
exports.WriteTreeCompleteChildSource = WriteTreeCompleteChildSource;

//# sourceMappingURL=CompleteChildSource.js.map


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Node_1 = __webpack_require__(5);
var Change_1 = __webpack_require__(9);
var util_1 = __webpack_require__(0);
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised. See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
 /**
 *
 * @param {!Query} query_
 */
 function EventGenerator(query_) {
 this.query_ = query_;
 /**
 * @private
 * @type {!Index}
 */
 this.index_ = this.query_.getQueryParams().getIndex();
 }
 /**
 * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
 * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
 *
 * Notes:
 * - child_moved events will be synthesized at this time for any child_changed events that affect
 * our index.
 * - prevName will be calculated based on the index ordering.
 *
 * @param {!Array.} changes
 * @param {!Node} eventCache
 * @param {!Array.} eventRegistrations
 * @return {!Array.}
 */
 EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
 var _this = this;
 var events = [];
 var moves = [];
 changes.forEach(function (change) {
 if (change.type === Change_1.Change.CHILD_CHANGED &&
 _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
 moves.push(Change_1.Change.childMovedChange(change.childName, change.snapshotNode));
 }
 });
 this.generateEventsForType_(events, Change_1.Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
 this.generateEventsForType_(events, Change_1.Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
 this.generateEventsForType_(events, Change_1.Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
 this.generateEventsForType_(events, Change_1.Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
 this.generateEventsForType_(events, Change_1.Change.VALUE, changes, eventRegistrations, eventCache);
 return events;
 };
 /**
 * Given changes of a single change type, generate the corresponding events.
 *
 * @param {!Array.} events
 * @param {!string} eventType
 * @param {!Array.} changes
 * @param {!Array.} registrations
 * @param {!Node} eventCache
 * @private
 */
 EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
 var _this = this;
 var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
 filteredChanges.sort(this.compareChanges_.bind(this));
 filteredChanges.forEach(function (change) {
 var materializedChange = _this.materializeSingleChange_(change, eventCache);
 registrations.forEach(function (registration) {
 if (registration.respondsTo(change.type)) {
 events.push(registration.createEvent(materializedChange, _this.query_));
 }
 });
 });
 };
 /**
 * @param {!Change} change
 * @param {!Node} eventCache
 * @return {!Change}
 * @private
 */
 EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
 if (change.type === 'value' || change.type === 'child_removed') {
 return change;
 }
 else {
 change.prevName = eventCache.getPredecessorChildName(
 /** @type {!string} */
 change.childName, change.snapshotNode, this.index_);
 return change;
 }
 };
 /**
 * @param {!Change} a
 * @param {!Change} b
 * @return {number}
 * @private
 */
 EventGenerator.prototype.compareChanges_ = function (a, b) {
 if (a.childName == null || b.childName == null) {
 throw util_1.assertionError('Should only compare child_ events.');
 }
 var aWrapped = new Node_1.NamedNode(a.childName, a.snapshotNode);
 var bWrapped = new Node_1.NamedNode(b.childName, b.snapshotNode);
 return this.index_.compare(aWrapped, bWrapped);
 };
 return EventGenerator;
}());
exports.EventGenerator = EventGenerator;

//# sourceMappingURL=EventGenerator.js.map


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var util_2 = __webpack_require__(0);
var Path_1 = __webpack_require__(2);
var CompoundWrite_1 = __webpack_require__(96);
var PriorityIndex_1 = __webpack_require__(3);
var ChildrenNode_1 = __webpack_require__(4);
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data). Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
 function WriteTree() {
 /**
 * A tree tracking the result of applying all visible writes. This does not include transactions with
 * applyLocally=false or writes that are completely shadowed by other writes.
 *
 * @type {!CompoundWrite}
 * @private
 */
 this.visibleWrites_ = CompoundWrite_1.CompoundWrite.Empty;
 /**
 * A list of all pending writes, regardless of visibility and shadowed-ness. Used to calculate arbitrary
 * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
 * used by transactions).
 *
 * @type {!Array.}
 * @private
 */
 this.allWrites_ = [];
 this.lastWriteId_ = -1;
 }
 /**
 * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
 *
 * @param {!Path} path
 * @return {!WriteTreeRef}
 */
 WriteTree.prototype.childWrites = function (path) {
 return new WriteTreeRef(path, this);
 };
 /**
 * Record a new overwrite from user code.
 *
 * @param {!Path} path
 * @param {!Node} snap
 * @param {!number} writeId
 * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
 */
 WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
 util_2.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
 if (visible === undefined) {
 visible = true;
 }
 this.allWrites_.push({
 path: path,
 snap: snap,
 writeId: writeId,
 visible: visible
 });
 if (visible) {
 this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
 }
 this.lastWriteId_ = writeId;
 };
 /**
 * Record a new merge from user code.
 *
 * @param {!Path} path
 * @param {!Object.} changedChildren
 * @param {!number} writeId
 */
 WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
 util_2.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
 this.allWrites_.push({
 path: path,
 children: changedChildren,
 writeId: writeId,
 visible: true
 });
 this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
 this.lastWriteId_ = writeId;
 };
 /**
 * @param {!number} writeId
 * @return {?WriteRecord}
 */
 WriteTree.prototype.getWrite = function (writeId) {
 for (var i = 0; i < this.allWrites_.length; i++) {
 var record = this.allWrites_[i];
 if (record.writeId === writeId) {
 return record;
 }
 }
 return null;
 };
 /**
 * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
 * the tree if necessary. We return true if it may have been visible, meaning views need to reevaluate.
 *
 * @param {!number} writeId
 * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
 * events as a result).
 */
 WriteTree.prototype.removeWrite = function (writeId) {
 // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
 // out of order.
 //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
 //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
 var _this = this;
 var idx = this.allWrites_.findIndex(function (s) {
 return s.writeId === writeId;
 });
 util_2.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
 var writeToRemove = this.allWrites_[idx];
 this.allWrites_.splice(idx, 1);
 var removedWriteWasVisible = writeToRemove.visible;
 var removedWriteOverlapsWithOtherWrites = false;
 var i = this.allWrites_.length - 1;
 while (removedWriteWasVisible && i >= 0) {
 var currentWrite = this.allWrites_[i];
 if (currentWrite.visible) {
 if (i >= idx &&
 this.recordContainsPath_(currentWrite, writeToRemove.path)) {
 // The removed write was completely shadowed by a subsequent write.
 removedWriteWasVisible = false;
 }
 else if (writeToRemove.path.contains(currentWrite.path)) {
 // Either we're covering some writes or they're covering part of us (depending on which came first).
 removedWriteOverlapsWithOtherWrites = true;
 }
 }
 i--;
 }
 if (!removedWriteWasVisible) {
 return false;
 }
 else if (removedWriteOverlapsWithOtherWrites) {
 // There's some shadowing going on. Just rebuild the visible writes from scratch.
 this.resetTree_();
 return true;
 }
 else {
 // There's no shadowing. We can safely just remove the write(s) from visibleWrites.
 if (writeToRemove.snap) {
 this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
 }
 else {
 var children = writeToRemove.children;
 util_1.forEach(children, function (childName) {
 _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
 });
 }
 return true;
 }
 };
 /**
 * Return a complete snapshot for the given path if there's visible write data at that path, else null.
 * No server data is considered.
 *
 * @param {!Path} path
 * @return {?Node}
 */
 WriteTree.prototype.getCompleteWriteData = function (path) {
 return this.visibleWrites_.getCompleteNode(path);
 };
 /**
 * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
 * writes), attempt to calculate a complete snapshot for the given path
 *
 * @param {!Path} treePath
 * @param {?Node} completeServerCache
 * @param {Array.=} writeIdsToExclude An optional set to be excluded
 * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
 * @return {?Node}
 */
 WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
 if (!writeIdsToExclude && !includeHiddenWrites) {
 var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
 if (shadowingNode != null) {
 return shadowingNode;
 }
 else {
 var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
 if (subMerge.isEmpty()) {
 return completeServerCache;
 }
 else if (completeServerCache == null &&
 !subMerge.hasCompleteWrite(Path_1.Path.Empty)) {
 // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
 return null;
 }
 else {
 var layeredCache = completeServerCache || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 return subMerge.apply(layeredCache);
 }
 }
 }
 else {
 var merge = this.visibleWrites_.childCompoundWrite(treePath);
 if (!includeHiddenWrites && merge.isEmpty()) {
 return completeServerCache;
 }
 else {
 // If the server cache is null, and we don't have a complete cache, we need to return null
 if (!includeHiddenWrites &&
 completeServerCache == null &&
 !merge.hasCompleteWrite(Path_1.Path.Empty)) {
 return null;
 }
 else {
 var filter = function (write) {
 return ((write.visible || includeHiddenWrites) &&
 (!writeIdsToExclude ||
 !~writeIdsToExclude.indexOf(write.writeId)) &&
 (write.path.contains(treePath) || treePath.contains(write.path)));
 };
 var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
 var layeredCache = completeServerCache || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 return mergeAtPath.apply(layeredCache);
 }
 }
 }
 };
 /**
 * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
 * Used when creating new views, to pre-fill their complete event children snapshot.
 *
 * @param {!Path} treePath
 * @param {?ChildrenNode} completeServerChildren
 * @return {!ChildrenNode}
 */
 WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
 var completeChildren = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
 if (topLevelSet) {
 if (!topLevelSet.isLeafNode()) {
 // we're shadowing everything. Return the children.
 topLevelSet.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childSnap) {
 completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
 });
 }
 return completeChildren;
 }
 else if (completeServerChildren) {
 // Layer any children we have on top of this
 // We know we don't have a top-level set, so just enumerate existing children
 var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
 completeServerChildren.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
 var node = merge_1
 .childCompoundWrite(new Path_1.Path(childName))
 .apply(childNode);
 completeChildren = completeChildren.updateImmediateChild(childName, node);
 });
 // Add any complete children we have from the set
 merge_1.getCompleteChildren().forEach(function (namedNode) {
 completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
 });
 return completeChildren;
 }
 else {
 // We don't have anything to layer on top of. Layer on any children we have
 // Note that we can return an empty snap if we have a defined delete
 var merge = this.visibleWrites_.childCompoundWrite(treePath);
 merge.getCompleteChildren().forEach(function (namedNode) {
 completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
 });
 return completeChildren;
 }
 };
 /**
 * Given that the underlying server data has updated, determine what, if anything, needs to be
 * applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events
 *
 * Either existingEventSnap or existingServerSnap must exist
 *
 * @param {!Path} treePath
 * @param {!Path} childPath
 * @param {?Node} existingEventSnap
 * @param {?Node} existingServerSnap
 * @return {?Node}
 */
 WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
 util_2.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
 var path = treePath.child(childPath);
 if (this.visibleWrites_.hasCompleteWrite(path)) {
 // At this point we can probably guarantee that we're in case 2, meaning no events
 // May need to check visibility while doing the findRootMostValueAndPath call
 return null;
 }
 else {
 // No complete shadowing. We're either partially shadowing or not shadowing at all.
 var childMerge = this.visibleWrites_.childCompoundWrite(path);
 if (childMerge.isEmpty()) {
 // We're not shadowing at all. Case 1
 return existingServerSnap.getChild(childPath);
 }
 else {
 // This could be more efficient if the serverNode + updates doesn't change the eventSnap
 // However this is tricky to find out, since user updates don't necessary change the server
 // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
 // adds nodes, but doesn't change any existing writes. It is therefore not enough to
 // only check if the updates change the serverNode.
 // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
 return childMerge.apply(existingServerSnap.getChild(childPath));
 }
 }
 };
 /**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 *
 * @param {!Path} treePath
 * @param {!string} childKey
 * @param {!CacheNode} existingServerSnap
 * @return {?Node}
 */
 WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
 var path = treePath.child(childKey);
 var shadowingNode = this.visibleWrites_.getCompleteNode(path);
 if (shadowingNode != null) {
 return shadowingNode;
 }
 else {
 if (existingServerSnap.isCompleteForChild(childKey)) {
 var childMerge = this.visibleWrites_.childCompoundWrite(path);
 return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
 }
 else {
 return null;
 }
 }
 };
 /**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 * @param {!Path} path
 * @return {?Node}
 */
 WriteTree.prototype.shadowingWrite = function (path) {
 return this.visibleWrites_.getCompleteNode(path);
 };
 /**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window.
 *
 * @param {!Path} treePath
 * @param {?Node} completeServerData
 * @param {!NamedNode} startPost
 * @param {!number} count
 * @param {boolean} reverse
 * @param {!Index} index
 * @return {!Array.}
 */
 WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
 var toIterate;
 var merge = this.visibleWrites_.childCompoundWrite(treePath);
 var shadowingNode = merge.getCompleteNode(Path_1.Path.Empty);
 if (shadowingNode != null) {
 toIterate = shadowingNode;
 }
 else if (completeServerData != null) {
 toIterate = merge.apply(completeServerData);
 }
 else {
 // no children to iterate on
 return [];
 }
 toIterate = toIterate.withIndex(index);
 if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
 var nodes = [];
 var cmp = index.getCompare();
 var iter = reverse
 ? toIterate.getReverseIteratorFrom(startPost, index)
 : toIterate.getIteratorFrom(startPost, index);
 var next = iter.getNext();
 while (next && nodes.length < count) {
 if (cmp(next, startPost) !== 0) {
 nodes.push(next);
 }
 next = iter.getNext();
 }
 return nodes;
 }
 else {
 return [];
 }
 };
 /**
 * @param {!WriteRecord} writeRecord
 * @param {!Path} path
 * @return {boolean}
 * @private
 */
 WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
 if (writeRecord.snap) {
 return writeRecord.path.contains(path);
 }
 else {
 // findKey can return undefined, so use !! to coerce to boolean
 return !!util_1.findKey(writeRecord.children, function (childSnap, childName) {
 return writeRecord.path.child(childName).contains(path);
 });
 }
 };
 /**
 * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
 * @private
 */
 WriteTree.prototype.resetTree_ = function () {
 this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path_1.Path.Empty);
 if (this.allWrites_.length > 0) {
 this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
 }
 else {
 this.lastWriteId_ = -1;
 }
 };
 /**
 * The default filter used when constructing the tree. Keep everything that's visible.
 *
 * @param {!WriteRecord} write
 * @return {boolean}
 * @private
 */
 WriteTree.DefaultFilter_ = function (write) {
 return write.visible;
 };
 /**
 * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
 * event data at that path.
 *
 * @param {!Array.} writes
 * @param {!function(!WriteRecord):boolean} filter
 * @param {!Path} treeRoot
 * @return {!CompoundWrite}
 * @private
 */
 WriteTree.layerTree_ = function (writes, filter, treeRoot) {
 var compoundWrite = CompoundWrite_1.CompoundWrite.Empty;
 for (var i = 0; i < writes.length; ++i) {
 var write = writes[i];
 // Theory, a later set will either:
 // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
 // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
 if (filter(write)) {
 var writePath = write.path;
 var relativePath = void 0;
 if (write.snap) {
 if (treeRoot.contains(writePath)) {
 relativePath = Path_1.Path.relativePath(treeRoot, writePath);
 compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
 }
 else if (writePath.contains(treeRoot)) {
 relativePath = Path_1.Path.relativePath(writePath, treeRoot);
 compoundWrite = compoundWrite.addWrite(Path_1.Path.Empty, write.snap.getChild(relativePath));
 }
 else {
 // There is no overlap between root path and write path, ignore write
 }
 }
 else if (write.children) {
 if (treeRoot.contains(writePath)) {
 relativePath = Path_1.Path.relativePath(treeRoot, writePath);
 compoundWrite = compoundWrite.addWrites(relativePath, write.children);
 }
 else if (writePath.contains(treeRoot)) {
 relativePath = Path_1.Path.relativePath(writePath, treeRoot);
 if (relativePath.isEmpty()) {
 compoundWrite = compoundWrite.addWrites(Path_1.Path.Empty, write.children);
 }
 else {
 var child = util_1.safeGet(write.children, relativePath.getFront());
 if (child) {
 // There exists a child in this node that matches the root path
 var deepNode = child.getChild(relativePath.popFront());
 compoundWrite = compoundWrite.addWrite(Path_1.Path.Empty, deepNode);
 }
 }
 }
 else {
 // There is no overlap between root path and write path, ignore write
 }
 }
 else {
 throw util_2.assertionError('WriteRecord should have .snap or .children');
 }
 }
 }
 return compoundWrite;
 };
 return WriteTree;
}());
exports.WriteTree = WriteTree;
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree. All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
 /**
 * @param {!Path} path
 * @param {!WriteTree} writeTree
 */
 function WriteTreeRef(path, writeTree) {
 this.treePath_ = path;
 this.writeTree_ = writeTree;
 }
 /**
 * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
 * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
 * can lead to a more expensive calculation.
 *
 * @param {?Node} completeServerCache
 * @param {Array.=} writeIdsToExclude Optional writes to exclude.
 * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
 * @return {?Node}
 */
 WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
 return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
 };
 /**
 * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
 * mix of the given server data and write data.
 *
 * @param {?ChildrenNode} completeServerChildren
 * @return {!ChildrenNode}
 */
 WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
 return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
 };
 /**
 * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
 * if anything, needs to be applied to the event cache.
 *
 * Possibilities:
 *
 * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
 *
 * 2. Some write is completely shadowing. No events to be raised
 *
 * 3. Is partially shadowed. Events should be raised
 *
 * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
 *
 * @param {!Path} path
 * @param {?Node} existingEventSnap
 * @param {?Node} existingServerSnap
 * @return {?Node}
 */
 WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
 return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
 };
 /**
 * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
 * a higher path, this will return the child of that write relative to the write and this path.
 * Returns null if there is no write at this path.
 *
 * @param {!Path} path
 * @return {?Node}
 */
 WriteTreeRef.prototype.shadowingWrite = function (path) {
 return this.writeTree_.shadowingWrite(this.treePath_.child(path));
 };
 /**
 * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
 * the window, but may now be in the window
 *
 * @param {?Node} completeServerData
 * @param {!NamedNode} startPost
 * @param {!number} count
 * @param {boolean} reverse
 * @param {!Index} index
 * @return {!Array.}
 */
 WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
 return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
 };
 /**
 * Returns a complete child for a given server snap after applying all user writes or null if there is no
 * complete child for this ChildKey.
 *
 * @param {!string} childKey
 * @param {!CacheNode} existingServerCache
 * @return {?Node}
 */
 WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
 return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
 };
 /**
 * Return a WriteTreeRef for a child.
 *
 * @param {string} childName
 * @return {!WriteTreeRef}
 */
 WriteTreeRef.prototype.child = function (childName) {
 return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
 };
 return WriteTreeRef;
}());
exports.WriteTreeRef = WriteTreeRef;

//# sourceMappingURL=WriteTree.js.map


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ImmutableTree_1 = __webpack_require__(23);
var Path_1 = __webpack_require__(2);
var util_1 = __webpack_require__(0);
var Node_1 = __webpack_require__(5);
var PriorityIndex_1 = __webpack_require__(3);
var util_2 = __webpack_require__(0);
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 *
 * @constructor
 * @param {!ImmutableTree.} writeTree
 */
var CompoundWrite = /** @class */ (function () {
 function CompoundWrite(writeTree_) {
 this.writeTree_ = writeTree_;
 }
 /**
 * @param {!Path} path
 * @param {!Node} node
 * @return {!CompoundWrite}
 */
 CompoundWrite.prototype.addWrite = function (path, node) {
 if (path.isEmpty()) {
 return new CompoundWrite(new ImmutableTree_1.ImmutableTree(node));
 }
 else {
 var rootmost = this.writeTree_.findRootMostValueAndPath(path);
 if (rootmost != null) {
 var rootMostPath = rootmost.path;
 var value = rootmost.value;
 var relativePath = Path_1.Path.relativePath(rootMostPath, path);
 value = value.updateChild(relativePath, node);
 return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
 }
 else {
 var subtree = new ImmutableTree_1.ImmutableTree(node);
 var newWriteTree = this.writeTree_.setTree(path, subtree);
 return new CompoundWrite(newWriteTree);
 }
 }
 };
 /**
 * @param {!Path} path
 * @param {!Object.} updates
 * @return {!CompoundWrite}
 */
 CompoundWrite.prototype.addWrites = function (path, updates) {
 var newWrite = this;
 util_1.forEach(updates, function (childKey, node) {
 newWrite = newWrite.addWrite(path.child(childKey), node);
 });
 return newWrite;
 };
 /**
 * Will remove a write at the given path and deeper paths. This will not modify a write at a higher
 * location, which must be removed by calling this method with that path.
 *
 * @param {!Path} path The path at which a write and all deeper writes should be removed
 * @return {!CompoundWrite} The new CompoundWrite with the removed path
 */
 CompoundWrite.prototype.removeWrite = function (path) {
 if (path.isEmpty()) {
 return CompoundWrite.Empty;
 }
 else {
 var newWriteTree = this.writeTree_.setTree(path, ImmutableTree_1.ImmutableTree.Empty);
 return new CompoundWrite(newWriteTree);
 }
 };
 /**
 * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
 * considered "complete".
 *
 * @param {!Path} path The path to check for
 * @return {boolean} Whether there is a complete write at that path
 */
 CompoundWrite.prototype.hasCompleteWrite = function (path) {
 return this.getCompleteNode(path) != null;
 };
 /**
 * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
 * writes from deeper paths, but will return child nodes from a more shallow path.
 *
 * @param {!Path} path The path to get a complete write
 * @return {?Node} The node if complete at that path, or null otherwise.
 */
 CompoundWrite.prototype.getCompleteNode = function (path) {
 var rootmost = this.writeTree_.findRootMostValueAndPath(path);
 if (rootmost != null) {
 return this.writeTree_
 .get(rootmost.path)
 .getChild(Path_1.Path.relativePath(rootmost.path, path));
 }
 else {
 return null;
 }
 };
 /**
 * Returns all children that are guaranteed to be a complete overwrite.
 *
 * @return {!Array.} A list of all complete children.
 */
 CompoundWrite.prototype.getCompleteChildren = function () {
 var children = [];
 var node = this.writeTree_.value;
 if (node != null) {
 // If it's a leaf node, it has no children; so nothing to do.
 if (!node.isLeafNode()) {
 node.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
 children.push(new Node_1.NamedNode(childName, childNode));
 });
 }
 }
 else {
 this.writeTree_.children.inorderTraversal(function (childName, childTree) {
 if (childTree.value != null) {
 children.push(new Node_1.NamedNode(childName, childTree.value));
 }
 });
 }
 return children;
 };
 /**
 * @param {!Path} path
 * @return {!CompoundWrite}
 */
 CompoundWrite.prototype.childCompoundWrite = function (path) {
 if (path.isEmpty()) {
 return this;
 }
 else {
 var shadowingNode = this.getCompleteNode(path);
 if (shadowingNode != null) {
 return new CompoundWrite(new ImmutableTree_1.ImmutableTree(shadowingNode));
 }
 else {
 return new CompoundWrite(this.writeTree_.subtree(path));
 }
 }
 };
 /**
 * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
 * @return {boolean} Whether this CompoundWrite is empty
 */
 CompoundWrite.prototype.isEmpty = function () {
 return this.writeTree_.isEmpty();
 };
 /**
 * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
 * node
 * @param {!Node} node The node to apply this CompoundWrite to
 * @return {!Node} The node with all writes applied
 */
 CompoundWrite.prototype.apply = function (node) {
 return CompoundWrite.applySubtreeWrite_(Path_1.Path.Empty, this.writeTree_, node);
 };
 /**
 * @type {!CompoundWrite}
 */
 CompoundWrite.Empty = new CompoundWrite(new ImmutableTree_1.ImmutableTree(null));
 /**
 * @param {!Path} relativePath
 * @param {!ImmutableTree.} writeTree
 * @param {!Node} node
 * @return {!Node}
 * @private
 */
 CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
 if (writeTree.value != null) {
 // Since there a write is always a leaf, we're done here
 return node.updateChild(relativePath, writeTree.value);
 }
 else {
 var priorityWrite_1 = null;
 writeTree.children.inorderTraversal(function (childKey, childTree) {
 if (childKey === '.priority') {
 // Apply priorities at the end so we don't update priorities for either empty nodes or forget
 // to apply priorities to empty nodes that are later filled
 util_2.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
 priorityWrite_1 = childTree.value;
 }
 else {
 node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
 }
 });
 // If there was a priority write, we only apply it if the node is not empty
 if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
 node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
 }
 return node;
 }
 };
 return CompoundWrite;
}());
exports.CompoundWrite = CompoundWrite;

//# sourceMappingURL=CompoundWrite.js.map


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ChildrenNode_1 = __webpack_require__(4);
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
 function SnapshotHolder() {
 this.rootNode_ = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 }
 SnapshotHolder.prototype.getNode = function (path) {
 return this.rootNode_.getChild(path);
 };
 SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
 this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
 };
 return SnapshotHolder;
}());
exports.SnapshotHolder = SnapshotHolder;

//# sourceMappingURL=SnapshotHolder.js.map


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(1);
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */ (function () {
 /**
 * @param {!FirebaseApp} app_
 */
 function AuthTokenProvider(app_) {
 this.app_ = app_;
 }
 /**
 * @param {boolean} forceRefresh
 * @return {!Promise}
 */
 AuthTokenProvider.prototype.getToken = function (forceRefresh) {
 return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
 // .catch
 function (error) {
 // TODO: Need to figure out all the cases this is raised and whether
 // this makes sense.
 if (error && error.code === 'auth/token-not-initialized') {
 util_1.log('Got auth/token-not-initialized error. Treating as null token.');
 return null;
 }
 else {
 return Promise.reject(error);
 }
 });
 };
 AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
 // TODO: We might want to wrap the listener and call it with no args to
 // avoid a leaky abstraction, but that makes removing the listener harder.
 this.app_['INTERNAL']['addAuthTokenListener'](listener);
 };
 AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
 this.app_['INTERNAL']['removeAuthTokenListener'](listener);
 };
 AuthTokenProvider.prototype.notifyForInvalidToken = function () {
 var errorMessage = 'Provided authentication credentials for the app named "' +
 this.app_.name +
 '" are invalid. This usually indicates your app was not ' +
 'initialized correctly. ';
 if ('credential' in this.app_.options) {
 errorMessage +=
 'Make sure the "credential" property provided to initializeApp() ' +
 'is authorized to access the specified "databaseURL" and is from the correct ' +
 'project.';
 }
 else if ('serviceAccount' in this.app_.options) {
 errorMessage +=
 'Make sure the "serviceAccount" property provided to initializeApp() ' +
 'is authorized to access the specified "databaseURL" and is from the correct ' +
 'project.';
 }
 else {
 errorMessage +=
 'Make sure the "apiKey" and "databaseURL" properties provided to ' +
 'initializeApp() match the values provided for your app at ' +
 'https://console.firebase.google.com/.';
 }
 util_1.warn(errorMessage);
 };
 return AuthTokenProvider;
}());
exports.AuthTokenProvider = AuthTokenProvider;

//# sourceMappingURL=AuthTokenProvider.js.map


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var util_2 = __webpack_require__(0);
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
 function StatsCollection() {
 this.counters_ = {};
 }
 StatsCollection.prototype.incrementCounter = function (name, amount) {
 if (amount === void 0) { amount = 1; }
 if (!util_2.contains(this.counters_, name))
 this.counters_[name] = 0;
 this.counters_[name] += amount;
 };
 StatsCollection.prototype.get = function () {
 return util_1.deepCopy(this.counters_);
 };
 return StatsCollection;
}());
exports.StatsCollection = StatsCollection;

//# sourceMappingURL=StatsCollection.js.map


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var util_2 = __webpack_require__(1);
var StatsListener_1 = __webpack_require__(49);
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
 /**
 * @param collection
 * @param server_
 */
 function StatsReporter(collection, server_) {
 this.server_ = server_;
 this.statsToReport_ = {};
 this.statsListener_ = new StatsListener_1.StatsListener(collection);
 var timeout = FIRST_STATS_MIN_TIME +
 (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
 util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
 }
 StatsReporter.prototype.includeStat = function (stat) {
 this.statsToReport_[stat] = true;
 };
 StatsReporter.prototype.reportStats_ = function () {
 var _this = this;
 var stats = this.statsListener_.get();
 var reportedStats = {};
 var haveStatsToReport = false;
 util_1.forEach(stats, function (stat, value) {
 if (value > 0 && util_1.contains(_this.statsToReport_, stat)) {
 reportedStats[stat] = value;
 haveStatsToReport = true;
 }
 });
 if (haveStatsToReport) {
 this.server_.reportStats(reportedStats);
 }
 // queue our next run.
 util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
 };
 return StatsReporter;
}());
exports.StatsReporter = StatsReporter;

//# sourceMappingURL=StatsReporter.js.map


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(1);
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 * events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely. That is, if in the course of raising events,
 * raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 * left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 * events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
 function EventQueue() {
 /**
 * @private
 * @type {!Array.}
 */
 this.eventLists_ = [];
 /**
 * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
 * @private
 * @type {!number}
 */
 this.recursionDepth_ = 0;
 }
 /**
 * @param {!Array.} eventDataList The new events to queue.
 */
 EventQueue.prototype.queueEvents = function (eventDataList) {
 // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
 var currList = null;
 for (var i = 0; i < eventDataList.length; i++) {
 var eventData = eventDataList[i];
 var eventPath = eventData.getPath();
 if (currList !== null && !eventPath.equals(currList.getPath())) {
 this.eventLists_.push(currList);
 currList = null;
 }
 if (currList === null) {
 currList = new EventList(eventPath);
 }
 currList.add(eventData);
 }
 if (currList) {
 this.eventLists_.push(currList);
 }
 };
 /**
 * Queues the specified events and synchronously raises all events (including previously queued ones)
 * for the specified path.
 *
 * It is assumed that the new events are all for the specified path.
 *
 * @param {!Path} path The path to raise events for.
 * @param {!Array.} eventDataList The new events to raise.
 */
 EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
 this.queueEvents(eventDataList);
 this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
 return eventPath.equals(path);
 });
 };
 /**
 * Queues the specified events and synchronously raises all events (including previously queued ones) for
 * locations related to the specified change path (i.e. all ancestors and descendants).
 *
 * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
 *
 * @param {!Path} changedPath The path to raise events for.
 * @param {!Array.} eventDataList The events to raise
 */
 EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
 this.queueEvents(eventDataList);
 this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
 return eventPath.contains(changedPath) || changedPath.contains(eventPath);
 });
 };
 /**
 * @param {!function(!Path):boolean} predicate
 * @private
 */
 EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
 this.recursionDepth_++;
 var sentAll = true;
 for (var i = 0; i < this.eventLists_.length; i++) {
 var eventList = this.eventLists_[i];
 if (eventList) {
 var eventPath = eventList.getPath();
 if (predicate(eventPath)) {
 this.eventLists_[i].raise();
 this.eventLists_[i] = null;
 }
 else {
 sentAll = false;
 }
 }
 }
 if (sentAll) {
 this.eventLists_ = [];
 }
 this.recursionDepth_--;
 };
 return EventQueue;
}());
exports.EventQueue = EventQueue;
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
 function EventList(path_) {
 this.path_ = path_;
 /**
 * @type {!Array.}
 * @private
 */
 this.events_ = [];
 }
 /**
 * @param {!Event} eventData
 */
 EventList.prototype.add = function (eventData) {
 this.events_.push(eventData);
 };
 /**
 * Iterates through the list and raises each event
 */
 EventList.prototype.raise = function () {
 for (var i = 0; i < this.events_.length; i++) {
 var eventData = this.events_[i];
 if (eventData !== null) {
 this.events_[i] = null;
 var eventFn = eventData.getEventRunner();
 if (util_1.logger) {
 util_1.log('event: ' + eventData.toString());
 }
 util_1.exceptionGuard(eventFn);
 }
 }
 };
 /**
 * @return {!Path}
 */
 EventList.prototype.getPath = function () {
 return this.path_;
 };
 return EventList;
}());
exports.EventList = EventList;

//# sourceMappingURL=EventQueue.js.map


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
 var extendStatics = Object.setPrototypeOf ||
 ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
 function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
 return function (d, b) {
 extendStatics(d, b);
 function __() { this.constructor = d; }
 d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
 };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var EventEmitter_1 = __webpack_require__(51);
var util_1 = __webpack_require__(0);
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
 __extends(VisibilityMonitor, _super);
 function VisibilityMonitor() {
 var _this = _super.call(this, ['visible']) || this;
 var hidden;
 var visibilityChange;
 if (typeof document !== 'undefined' &&
 typeof document.addEventListener !== 'undefined') {
 if (typeof document['hidden'] !== 'undefined') {
 // Opera 12.10 and Firefox 18 and later support
 visibilityChange = 'visibilitychange';
 hidden = 'hidden';
 }
 else if (typeof document['mozHidden'] !== 'undefined') {
 visibilityChange = 'mozvisibilitychange';
 hidden = 'mozHidden';
 }
 else if (typeof document['msHidden'] !== 'undefined') {
 visibilityChange = 'msvisibilitychange';
 hidden = 'msHidden';
 }
 else if (typeof document['webkitHidden'] !== 'undefined') {
 visibilityChange = 'webkitvisibilitychange';
 hidden = 'webkitHidden';
 }
 }
 // Initially, we always assume we are visible. This ensures that in browsers
 // without page visibility support or in cases where we are never visible
 // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
 // reconnects
 _this.visible_ = true;
 if (visibilityChange) {
 document.addEventListener(visibilityChange, function () {
 var visible = !document[hidden];
 if (visible !== _this.visible_) {
 _this.visible_ = visible;
 _this.trigger('visible', visible);
 }
 }, false);
 }
 return _this;
 }
 VisibilityMonitor.getInstance = function () {
 return new VisibilityMonitor();
 };
 /**
 * @param {!string} eventType
 * @return {Array.}
 */
 VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
 util_1.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
 return [this.visible_];
 };
 return VisibilityMonitor;
}(EventEmitter_1.EventEmitter));
exports.VisibilityMonitor = VisibilityMonitor;

//# sourceMappingURL=VisibilityMonitor.js.map


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
 var extendStatics = Object.setPrototypeOf ||
 ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
 function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
 return function (d, b) {
 extendStatics(d, b);
 function __() { this.constructor = d; }
 d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
 };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var EventEmitter_1 = __webpack_require__(51);
var util_2 = __webpack_require__(0);
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives. So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
 __extends(OnlineMonitor, _super);
 function OnlineMonitor() {
 var _this = _super.call(this, ['online']) || this;
 _this.online_ = true;
 // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
 // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
 // It would seem that the 'online' event does not always fire consistently. So we disable it
 // for Cordova.
 if (typeof window !== 'undefined' &&
 typeof window.addEventListener !== 'undefined' &&
 !util_2.isMobileCordova()) {
 window.addEventListener('online', function () {
 if (!_this.online_) {
 _this.online_ = true;
 _this.trigger('online', true);
 }
 }, false);
 window.addEventListener('offline', function () {
 if (_this.online_) {
 _this.online_ = false;
 _this.trigger('online', false);
 }
 }, false);
 }
 return _this;
 }
 OnlineMonitor.getInstance = function () {
 return new OnlineMonitor();
 };
 /**
 * @param {!string} eventType
 * @return {Array.}
 */
 OnlineMonitor.prototype.getInitialEvent = function (eventType) {
 util_1.assert(eventType === 'online', 'Unknown event type: ' + eventType);
 return [this.online_];
 };
 /**
 * @return {boolean}
 */
 OnlineMonitor.prototype.currentlyOnline = function () {
 return this.online_;
 };
 return OnlineMonitor;
}(EventEmitter_1.EventEmitter));
exports.OnlineMonitor = OnlineMonitor;

//# sourceMappingURL=OnlineMonitor.js.map


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserPollConnection_1 = __webpack_require__(53);
var WebSocketConnection_1 = __webpack_require__(54);
var util_1 = __webpack_require__(1);
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
 /**
 * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
 */
 function TransportManager(repoInfo) {
 this.initTransports_(repoInfo);
 }
 Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
 /**
 * @const
 * @type {!Array.}
 */
 get: function () {
 return [BrowserPollConnection_1.BrowserPollConnection, WebSocketConnection_1.WebSocketConnection];
 },
 enumerable: true,
 configurable: true
 });
 /**
 * @param {!RepoInfo} repoInfo
 * @private
 */
 TransportManager.prototype.initTransports_ = function (repoInfo) {
 var isWebSocketsAvailable = WebSocketConnection_1.WebSocketConnection && WebSocketConnection_1.WebSocketConnection['isAvailable']();
 var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection_1.WebSocketConnection.previouslyFailed();
 if (repoInfo.webSocketOnly) {
 if (!isWebSocketsAvailable)
 util_1.warn("wss:// URL used, but browser isn't known to support websockets. Trying anyway.");
 isSkipPollConnection = true;
 }
 if (isSkipPollConnection) {
 this.transports_ = [WebSocketConnection_1.WebSocketConnection];
 }
 else {
 var transports_1 = (this.transports_ = []);
 util_1.each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
 if (transport && transport['isAvailable']()) {
 transports_1.push(transport);
 }
 });
 }
 };
 /**
 * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
 * initial transport to use
 */
 TransportManager.prototype.initialTransport = function () {
 if (this.transports_.length > 0) {
 return this.transports_[0];
 }
 else {
 throw new Error('No transports available');
 }
 };
 /**
 * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
 * transport, or null
 */
 TransportManager.prototype.upgradeTransport = function () {
 if (this.transports_.length > 1) {
 return this.transports_[1];
 }
 else {
 return null;
 }
 };
 return TransportManager;
}());
exports.TransportManager = TransportManager;

//# sourceMappingURL=TransportManager.js.map


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(1);
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
 /**
 * @param onMessage_
 */
 function PacketReceiver(onMessage_) {
 this.onMessage_ = onMessage_;
 this.pendingResponses = [];
 this.currentResponseNum = 0;
 this.closeAfterResponse = -1;
 this.onClose = null;
 }
 PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
 this.closeAfterResponse = responseNum;
 this.onClose = callback;
 if (this.closeAfterResponse < this.currentResponseNum) {
 this.onClose();
 this.onClose = null;
 }
 };
 /**
 * Each message from the server comes with a response number, and an array of data. The responseNumber
 * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
 * browsers will respond in the same order as the requests we sent
 * @param {number} requestNum
 * @param {Array} data
 */
 PacketReceiver.prototype.handleResponse = function (requestNum, data) {
 var _this = this;
 this.pendingResponses[requestNum] = data;
 var _loop_1 = function () {
 var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
 delete this_1.pendingResponses[this_1.currentResponseNum];
 var _loop_2 = function (i) {
 if (toProcess[i]) {
 util_1.exceptionGuard(function () {
 _this.onMessage_(toProcess[i]);
 });
 }
 };
 for (var i = 0; i < toProcess.length; ++i) {
 _loop_2(i);
 }
 if (this_1.currentResponseNum === this_1.closeAfterResponse) {
 if (this_1.onClose) {
 this_1.onClose();
 this_1.onClose = null;
 }
 return "break";
 }
 this_1.currentResponseNum++;
 };
 var this_1 = this;
 while (this.pendingResponses[this.currentResponseNum]) {
 var state_1 = _loop_1();
 if (state_1 === "break")
 break;
 }
 };
 return PacketReceiver;
}());
exports.PacketReceiver = PacketReceiver;

//# sourceMappingURL=PacketReceiver.js.map


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
 var extendStatics = Object.setPrototypeOf ||
 ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
 function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
 return function (d, b) {
 extendStatics(d, b);
 function __() { this.constructor = d; }
 d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
 };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var util_2 = __webpack_require__(1);
var util_3 = __webpack_require__(0);
var util_4 = __webpack_require__(0);
var util_5 = __webpack_require__(0);
var ServerActions_1 = __webpack_require__(55);
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
 __extends(ReadonlyRestClient, _super);
 /**
 * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
 * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
 * @param {AuthTokenProvider} authTokenProvider_
 * @implements {ServerActions}
 */
 function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
 var _this = _super.call(this) || this;
 _this.repoInfo_ = repoInfo_;
 _this.onDataUpdate_ = onDataUpdate_;
 _this.authTokenProvider_ = authTokenProvider_;
 /** @private {function(...[*])} */
 _this.log_ = util_2.logWrapper('p:rest:');
 /**
 * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
 * that's been removed. :-/
 *
 * @private {!Object.}
 */
 _this.listens_ = {};
 return _this;
 }
 ReadonlyRestClient.prototype.reportStats = function (stats) {
 throw new Error('Method not implemented.');
 };
 /**
 * @param {!Query} query
 * @param {?number=} tag
 * @return {string}
 * @private
 */
 ReadonlyRestClient.getListenId_ = function (query, tag) {
 if (tag !== undefined) {
 return 'tag$' + tag;
 }
 else {
 util_1.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
 return query.path.toString();
 }
 };
 /** @inheritDoc */
 ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
 var _this = this;
 var pathString = query.path.toString();
 this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
 // Mark this listener so we can tell if it's removed.
 var listenId = ReadonlyRestClient.getListenId_(query, tag);
 var thisListen = {};
 this.listens_[listenId] = thisListen;
 var queryStringParamaters = query
 .getQueryParams()
 .toRestQueryStringParameters();
 this.restRequest_(pathString + '.json', queryStringParamaters, function (error, result) {
 var data = result;
 if (error === 404) {
 data = null;
 error = null;
 }
 if (error === null) {
 _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
 }
 if (util_4.safeGet(_this.listens_, listenId) === thisListen) {
 var status_1;
 if (!error) {
 status_1 = 'ok';
 }
 else if (error == 401) {
 status_1 = 'permission_denied';
 }
 else {
 status_1 = 'rest_error:' + error;
 }
 onComplete(status_1, null);
 }
 });
 };
 /** @inheritDoc */
 ReadonlyRestClient.prototype.unlisten = function (query, tag) {
 var listenId = ReadonlyRestClient.getListenId_(query, tag);
 delete this.listens_[listenId];
 };
 /** @inheritDoc */
 ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
 // no-op since we just always call getToken.
 };
 /**
 * Performs a REST request to the given path, with the provided query string parameters,
 * and any auth credentials we have.
 *
 * @param {!string} pathString
 * @param {!Object.} queryStringParameters
 * @param {?function(?number, *=)} callback
 * @private
 */
 ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
 var _this = this;
 if (queryStringParameters === void 0) { queryStringParameters = {}; }
 queryStringParameters['format'] = 'export';
 this.authTokenProvider_
 .getToken(/*forceRefresh=*/ false)
 .then(function (authTokenData) {
 var authToken = authTokenData && authTokenData.accessToken;
 if (authToken) {
 queryStringParameters['auth'] = authToken;
 }
 var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
 _this.repoInfo_.host +
 pathString +
 '?' +
 util_5.querystring(queryStringParameters);
 _this.log_('Sending REST request for ' + url);
 var xhr = new XMLHttpRequest();
 xhr.onreadystatechange = function () {
 if (callback && xhr.readyState === 4) {
 _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
 var res = null;
 if (xhr.status >= 200 && xhr.status < 300) {
 try {
 res = util_3.jsonEval(xhr.responseText);
 }
 catch (e) {
 util_2.warn('Failed to parse JSON response for ' +
 url +
 ': ' +
 xhr.responseText);
 }
 callback(null, res);
 }
 else {
 // 401 and 404 are expected.
 if (xhr.status !== 401 && xhr.status !== 404) {
 util_2.warn('Got unsuccessful REST response for ' +
 url +
 ' Status: ' +
 xhr.status);
 }
 callback(xhr.status);
 }
 callback = null;
 }
 };
 xhr.open('GET', url, /*asynchronous=*/ true);
 xhr.send();
 });
 };
 return ReadonlyRestClient;
}(ServerActions_1.ServerActions));
exports.ReadonlyRestClient = ReadonlyRestClient;

//# sourceMappingURL=ReadonlyRestClient.js.map


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var util_2 = __webpack_require__(1);
var KeyIndex_1 = __webpack_require__(10);
var PriorityIndex_1 = __webpack_require__(3);
var ValueIndex_1 = __webpack_require__(38);
var PathIndex_1 = __webpack_require__(42);
var IndexedFilter_1 = __webpack_require__(24);
var LimitedFilter_1 = __webpack_require__(108);
var RangedFilter_1 = __webpack_require__(56);
var util_3 = __webpack_require__(0);
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
 function QueryParams() {
 this.limitSet_ = false;
 this.startSet_ = false;
 this.startNameSet_ = false;
 this.endSet_ = false;
 this.endNameSet_ = false;
 this.limit_ = 0;
 this.viewFrom_ = '';
 this.indexStartValue_ = null;
 this.indexStartName_ = '';
 this.indexEndValue_ = null;
 this.indexEndName_ = '';
 this.index_ = PriorityIndex_1.PRIORITY_INDEX;
 }
 /**
 * @return {boolean}
 */
 QueryParams.prototype.hasStart = function () {
 return this.startSet_;
 };
 /**
 * @return {boolean} True if it would return from left.
 */
 QueryParams.prototype.isViewFromLeft = function () {
 if (this.viewFrom_ === '') {
 // limit(), rather than limitToFirst or limitToLast was called.
 // This means that only one of startSet_ and endSet_ is true. Use them
 // to calculate which side of the view to anchor to. If neither is set,
 // anchor to the end.
 return this.startSet_;
 }
 else {
 return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
 }
 };
 /**
 * Only valid to call if hasStart() returns true
 * @return {*}
 */
 QueryParams.prototype.getIndexStartValue = function () {
 util_1.assert(this.startSet_, 'Only valid if start has been set');
 return this.indexStartValue_;
 };
 /**
 * Only valid to call if hasStart() returns true.
 * Returns the starting key name for the range defined by these query parameters
 * @return {!string}
 */
 QueryParams.prototype.getIndexStartName = function () {
 util_1.assert(this.startSet_, 'Only valid if start has been set');
 if (this.startNameSet_) {
 return this.indexStartName_;
 }
 else {
 return util_2.MIN_NAME;
 }
 };
 /**
 * @return {boolean}
 */
 QueryParams.prototype.hasEnd = function () {
 return this.endSet_;
 };
 /**
 * Only valid to call if hasEnd() returns true.
 * @return {*}
 */
 QueryParams.prototype.getIndexEndValue = function () {
 util_1.assert(this.endSet_, 'Only valid if end has been set');
 return this.indexEndValue_;
 };
 /**
 * Only valid to call if hasEnd() returns true.
 * Returns the end key name for the range defined by these query parameters
 * @return {!string}
 */
 QueryParams.prototype.getIndexEndName = function () {
 util_1.assert(this.endSet_, 'Only valid if end has been set');
 if (this.endNameSet_) {
 return this.indexEndName_;
 }
 else {
 return util_2.MAX_NAME;
 }
 };
 /**
 * @return {boolean}
 */
 QueryParams.prototype.hasLimit = function () {
 return this.limitSet_;
 };
 /**
 * @return {boolean} True if a limit has been set and it has been explicitly anchored
 */
 QueryParams.prototype.hasAnchoredLimit = function () {
 return this.limitSet_ && this.viewFrom_ !== '';
 };
 /**
 * Only valid to call if hasLimit() returns true
 * @return {!number}
 */
 QueryParams.prototype.getLimit = function () {
 util_1.assert(this.limitSet_, 'Only valid if limit has been set');
 return this.limit_;
 };
 /**
 * @return {!Index}
 */
 QueryParams.prototype.getIndex = function () {
 return this.index_;
 };
 /**
 * @return {!QueryParams}
 * @private
 */
 QueryParams.prototype.copy_ = function () {
 var copy = new QueryParams();
 copy.limitSet_ = this.limitSet_;
 copy.limit_ = this.limit_;
 copy.startSet_ = this.startSet_;
 copy.indexStartValue_ = this.indexStartValue_;
 copy.startNameSet_ = this.startNameSet_;
 copy.indexStartName_ = this.indexStartName_;
 copy.endSet_ = this.endSet_;
 copy.indexEndValue_ = this.indexEndValue_;
 copy.endNameSet_ = this.endNameSet_;
 copy.indexEndName_ = this.indexEndName_;
 copy.index_ = this.index_;
 copy.viewFrom_ = this.viewFrom_;
 return copy;
 };
 /**
 * @param {!number} newLimit
 * @return {!QueryParams}
 */
 QueryParams.prototype.limit = function (newLimit) {
 var newParams = this.copy_();
 newParams.limitSet_ = true;
 newParams.limit_ = newLimit;
 newParams.viewFrom_ = '';
 return newParams;
 };
 /**
 * @param {!number} newLimit
 * @return {!QueryParams}
 */
 QueryParams.prototype.limitToFirst = function (newLimit) {
 var newParams = this.copy_();
 newParams.limitSet_ = true;
 newParams.limit_ = newLimit;
 newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
 return newParams;
 };
 /**
 * @param {!number} newLimit
 * @return {!QueryParams}
 */
 QueryParams.prototype.limitToLast = function (newLimit) {
 var newParams = this.copy_();
 newParams.limitSet_ = true;
 newParams.limit_ = newLimit;
 newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
 return newParams;
 };
 /**
 * @param {*} indexValue
 * @param {?string=} key
 * @return {!QueryParams}
 */
 QueryParams.prototype.startAt = function (indexValue, key) {
 var newParams = this.copy_();
 newParams.startSet_ = true;
 if (!(indexValue !== undefined)) {
 indexValue = null;
 }
 newParams.indexStartValue_ = indexValue;
 if (key != null) {
 newParams.startNameSet_ = true;
 newParams.indexStartName_ = key;
 }
 else {
 newParams.startNameSet_ = false;
 newParams.indexStartName_ = '';
 }
 return newParams;
 };
 /**
 * @param {*} indexValue
 * @param {?string=} key
 * @return {!QueryParams}
 */
 QueryParams.prototype.endAt = function (indexValue, key) {
 var newParams = this.copy_();
 newParams.endSet_ = true;
 if (!(indexValue !== undefined)) {
 indexValue = null;
 }
 newParams.indexEndValue_ = indexValue;
 if (key !== undefined) {
 newParams.endNameSet_ = true;
 newParams.indexEndName_ = key;
 }
 else {
 newParams.endNameSet_ = false;
 newParams.indexEndName_ = '';
 }
 return newParams;
 };
 /**
 * @param {!Index} index
 * @return {!QueryParams}
 */
 QueryParams.prototype.orderBy = function (index) {
 var newParams = this.copy_();
 newParams.index_ = index;
 return newParams;
 };
 /**
 * @return {!Object}
 */
 QueryParams.prototype.getQueryObject = function () {
 var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
 var obj = {};
 if (this.startSet_) {
 obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
 if (this.startNameSet_) {
 obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
 }
 }
 if (this.endSet_) {
 obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
 if (this.endNameSet_) {
 obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
 }
 }
 if (this.limitSet_) {
 obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
 var viewFrom = this.viewFrom_;
 if (viewFrom === '') {
 if (this.isViewFromLeft()) {
 viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
 }
 else {
 viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
 }
 }
 obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
 }
 // For now, priority index is the default, so we only specify if it's some other index
 if (this.index_ !== PriorityIndex_1.PRIORITY_INDEX) {
 obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
 }
 return obj;
 };
 /**
 * @return {boolean}
 */
 QueryParams.prototype.loadsAllData = function () {
 return !(this.startSet_ || this.endSet_ || this.limitSet_);
 };
 /**
 * @return {boolean}
 */
 QueryParams.prototype.isDefault = function () {
 return this.loadsAllData() && this.index_ == PriorityIndex_1.PRIORITY_INDEX;
 };
 /**
 * @return {!NodeFilter}
 */
 QueryParams.prototype.getNodeFilter = function () {
 if (this.loadsAllData()) {
 return new IndexedFilter_1.IndexedFilter(this.getIndex());
 }
 else if (this.hasLimit()) {
 return new LimitedFilter_1.LimitedFilter(this);
 }
 else {
 return new RangedFilter_1.RangedFilter(this);
 }
 };
 /**
 * Returns a set of REST query string parameters representing this query.
 *
 * @return {!Object.} query string parameters
 */
 QueryParams.prototype.toRestQueryStringParameters = function () {
 var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
 var qs = {};
 if (this.isDefault()) {
 return qs;
 }
 var orderBy;
 if (this.index_ === PriorityIndex_1.PRIORITY_INDEX) {
 orderBy = REST_CONSTANTS.PRIORITY_INDEX;
 }
 else if (this.index_ === ValueIndex_1.VALUE_INDEX) {
 orderBy = REST_CONSTANTS.VALUE_INDEX;
 }
 else if (this.index_ === KeyIndex_1.KEY_INDEX) {
 orderBy = REST_CONSTANTS.KEY_INDEX;
 }
 else {
 util_1.assert(this.index_ instanceof PathIndex_1.PathIndex, 'Unrecognized index type!');
 orderBy = this.index_.toString();
 }
 qs[REST_CONSTANTS.ORDER_BY] = util_3.stringify(orderBy);
 if (this.startSet_) {
 qs[REST_CONSTANTS.START_AT] = util_3.stringify(this.indexStartValue_);
 if (this.startNameSet_) {
 qs[REST_CONSTANTS.START_AT] += ',' + util_3.stringify(this.indexStartName_);
 }
 }
 if (this.endSet_) {
 qs[REST_CONSTANTS.END_AT] = util_3.stringify(this.indexEndValue_);
 if (this.endNameSet_) {
 qs[REST_CONSTANTS.END_AT] += ',' + util_3.stringify(this.indexEndName_);
 }
 }
 if (this.limitSet_) {
 if (this.isViewFromLeft()) {
 qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
 }
 else {
 qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
 }
 }
 return qs;
 };
 /**
 * Wire Protocol Constants
 * @const
 * @enum {string}
 * @private
 */
 QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
 INDEX_START_VALUE: 'sp',
 INDEX_START_NAME: 'sn',
 INDEX_END_VALUE: 'ep',
 INDEX_END_NAME: 'en',
 LIMIT: 'l',
 VIEW_FROM: 'vf',
 VIEW_FROM_LEFT: 'l',
 VIEW_FROM_RIGHT: 'r',
 INDEX: 'i'
 };
 /**
 * REST Query Constants
 * @const
 * @enum {string}
 * @private
 */
 QueryParams.REST_QUERY_CONSTANTS_ = {
 ORDER_BY: 'orderBy',
 PRIORITY_INDEX: '$priority',
 VALUE_INDEX: '$value',
 KEY_INDEX: '$key',
 START_AT: 'startAt',
 END_AT: 'endAt',
 LIMIT_TO_FIRST: 'limitToFirst',
 LIMIT_TO_LAST: 'limitToLast'
 };
 /**
 * Default, empty query parameters
 * @type {!QueryParams}
 * @const
 */
 QueryParams.DEFAULT = new QueryParams();
 return QueryParams;
}());
exports.QueryParams = QueryParams;

//# sourceMappingURL=QueryParams.js.map


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var RangedFilter_1 = __webpack_require__(56);
var ChildrenNode_1 = __webpack_require__(4);
var Node_1 = __webpack_require__(5);
var util_1 = __webpack_require__(0);
var Change_1 = __webpack_require__(9);
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
 /**
 * @param {!QueryParams} params
 */
 function LimitedFilter(params) {
 this.rangedFilter_ = new RangedFilter_1.RangedFilter(params);
 this.index_ = params.getIndex();
 this.limit_ = params.getLimit();
 this.reverse_ = !params.isViewFromLeft();
 }
 /**
 * @inheritDoc
 */
 LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
 if (!this.rangedFilter_.matches(new Node_1.NamedNode(key, newChild))) {
 newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 }
 if (snap.getImmediateChild(key).equals(newChild)) {
 // No change
 return snap;
 }
 else if (snap.numChildren() < this.limit_) {
 return this.rangedFilter_
 .getIndexedFilter()
 .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
 }
 else {
 return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
 }
 };
 /**
 * @inheritDoc
 */
 LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
 var filtered;
 if (newSnap.isLeafNode() || newSnap.isEmpty()) {
 // Make sure we have a children node with the correct index, not a leaf node;
 filtered = ChildrenNode_1.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
 }
 else {
 if (this.limit_ * 2 < newSnap.numChildren() &&
 newSnap.isIndexed(this.index_)) {
 // Easier to build up a snapshot, since what we're given has more than twice the elements we want
 filtered = ChildrenNode_1.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
 // anchor to the startPost, endPost, or last element as appropriate
 var iterator = void 0;
 if (this.reverse_) {
 iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
 }
 else {
 iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
 }
 var count = 0;
 while (iterator.hasNext() && count < this.limit_) {
 var next = iterator.getNext();
 var inRange = void 0;
 if (this.reverse_) {
 inRange =
 this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
 }
 else {
 inRange =
 this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
 }
 if (inRange) {
 filtered = filtered.updateImmediateChild(next.name, next.node);
 count++;
 }
 else {
 // if we have reached the end post, we cannot keep adding elemments
 break;
 }
 }
 }
 else {
 // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
 filtered = newSnap.withIndex(this.index_);
 // Don't support priorities on queries
 filtered = filtered.updatePriority(ChildrenNode_1.ChildrenNode.EMPTY_NODE);
 var startPost = void 0;
 var endPost = void 0;
 var cmp = void 0;
 var iterator = void 0;
 if (this.reverse_) {
 iterator = filtered.getReverseIterator(this.index_);
 startPost = this.rangedFilter_.getEndPost();
 endPost = this.rangedFilter_.getStartPost();
 var indexCompare_1 = this.index_.getCompare();
 cmp = function (a, b) { return indexCompare_1(b, a); };
 }
 else {
 iterator = filtered.getIterator(this.index_);
 startPost = this.rangedFilter_.getStartPost();
 endPost = this.rangedFilter_.getEndPost();
 cmp = this.index_.getCompare();
 }
 var count = 0;
 var foundStartPost = false;
 while (iterator.hasNext()) {
 var next = iterator.getNext();
 if (!foundStartPost && cmp(startPost, next) <= 0) {
 // start adding
 foundStartPost = true;
 }
 var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
 if (inRange) {
 count++;
 }
 else {
 filtered = filtered.updateImmediateChild(next.name, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
 }
 }
 }
 }
 return this.rangedFilter_
 .getIndexedFilter()
 .updateFullNode(oldSnap, filtered, optChangeAccumulator);
 };
 /**
 * @inheritDoc
 */
 LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
 // Don't support priorities on queries
 return oldSnap;
 };
 /**
 * @inheritDoc
 */
 LimitedFilter.prototype.filtersNodes = function () {
 return true;
 };
 /**
 * @inheritDoc
 */
 LimitedFilter.prototype.getIndexedFilter = function () {
 return this.rangedFilter_.getIndexedFilter();
 };
 /**
 * @inheritDoc
 */
 LimitedFilter.prototype.getIndex = function () {
 return this.index_;
 };
 /**
 * @param {!Node} snap
 * @param {string} childKey
 * @param {!Node} childSnap
 * @param {!CompleteChildSource} source
 * @param {?ChildChangeAccumulator} changeAccumulator
 * @return {!Node}
 * @private
 */
 LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
 // TODO: rename all cache stuff etc to general snap terminology
 var cmp;
 if (this.reverse_) {
 var indexCmp_1 = this.index_.getCompare();
 cmp = function (a, b) { return indexCmp_1(b, a); };
 }
 else {
 cmp = this.index_.getCompare();
 }
 var oldEventCache = snap;
 util_1.assert(oldEventCache.numChildren() == this.limit_, '');
 var newChildNamedNode = new Node_1.NamedNode(childKey, childSnap);
 var windowBoundary = this.reverse_
 ? oldEventCache.getFirstChild(this.index_)
 : oldEventCache.getLastChild(this.index_);
 var inRange = this.rangedFilter_.matches(newChildNamedNode);
 if (oldEventCache.hasChild(childKey)) {
 var oldChildSnap = oldEventCache.getImmediateChild(childKey);
 var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
 while (nextChild != null &&
 (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
 // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
 // been applied to the limited filter yet. Ignore this next child which will be updated later in
 // the limited filter...
 nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
 }
 var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
 var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
 if (remainsInWindow) {
 if (changeAccumulator != null) {
 changeAccumulator.trackChildChange(Change_1.Change.childChangedChange(childKey, childSnap, oldChildSnap));
 }
 return oldEventCache.updateImmediateChild(childKey, childSnap);
 }
 else {
 if (changeAccumulator != null) {
 changeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(childKey, oldChildSnap));
 }
 var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
 var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
 if (nextChildInRange) {
 if (changeAccumulator != null) {
 changeAccumulator.trackChildChange(Change_1.Change.childAddedChange(nextChild.name, nextChild.node));
 }
 return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
 }
 else {
 return newEventCache;
 }
 }
 }
 else if (childSnap.isEmpty()) {
 // we're deleting a node, but it was not in the window, so ignore it
 return snap;
 }
 else if (inRange) {
 if (cmp(windowBoundary, newChildNamedNode) >= 0) {
 if (changeAccumulator != null) {
 changeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
 changeAccumulator.trackChildChange(Change_1.Change.childAddedChange(childKey, childSnap));
 }
 return oldEventCache
 .updateImmediateChild(childKey, childSnap)
 .updateImmediateChild(windowBoundary.name, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
 }
 else {
 return snap;
 }
 }
 else {
 return snap;
 }
 };
 return LimitedFilter;
}());
exports.LimitedFilter = LimitedFilter;

//# sourceMappingURL=LimitedFilter.js.map


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var Reference_1 = __webpack_require__(21);
var DataSnapshot_1 = __webpack_require__(22);
var Path_1 = __webpack_require__(2);
var Tree_1 = __webpack_require__(110);
var PriorityIndex_1 = __webpack_require__(3);
var util_2 = __webpack_require__(1);
var ServerValues_1 = __webpack_require__(43);
var validation_1 = __webpack_require__(7);
var util_3 = __webpack_require__(0);
var nodeFromJSON_1 = __webpack_require__(11);
var ChildrenNode_1 = __webpack_require__(4);
var Repo_1 = __webpack_require__(17);
// TODO: This is pretty messy. Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server). So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
 // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
 // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
 // mismatched hash.
 TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
 // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
 // or rejected yet).
 TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
 // Temporary state used to mark completed transactions (whether successful or aborted). The transaction will be
 // removed when we get a chance to prune completed ones.
 TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
 // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
 // If it comes back as unsuccessful, we'll abort it.
 TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
 // Temporary state used to mark transactions that need to be aborted.
 TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it. Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
Repo_1.Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
Repo_1.Repo.prototype.transactions_init_ = function () {
 /**
 * Stores queues of outstanding transactions for Firebase locations.
 *
 * @type {!Tree.>}
 * @private
 */
 this.transactionQueueTree_ = new Tree_1.Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo_1.Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
 this.log_('transaction on ' + path);
 // Add a watch to make sure we get server updates.
 var valueCallback = function () { };
 var watchRef = new Reference_1.Reference(this, path);
 watchRef.on('value', valueCallback);
 var unwatcher = function () {
 watchRef.off('value', valueCallback);
 };
 // Initialize transaction.
 var transaction = {
 path: path,
 update: transactionUpdate,
 onComplete: onComplete,
 // One of TransactionStatus enums.
 status: null,
 // Used when combining transactions at different locations to figure out which one goes first.
 order: util_2.LUIDGenerator(),
 // Whether to raise local events for this transaction.
 applyLocally: applyLocally,
 // Count of how many times we've retried the transaction.
 retryCount: 0,
 // Function to call to clean up our .on() listener.
 unwatcher: unwatcher,
 // Stores why a transaction was aborted.
 abortReason: null,
 currentWriteId: null,
 currentInputSnapshot: null,
 currentOutputSnapshotRaw: null,
 currentOutputSnapshotResolved: null
 };
 // Run transaction initially.
 var currentState = this.getLatestState_(path);
 transaction.currentInputSnapshot = currentState;
 var newVal = transaction.update(currentState.val());
 if (newVal === undefined) {
 // Abort transaction.
 transaction.unwatcher();
 transaction.currentOutputSnapshotRaw = null;
 transaction.currentOutputSnapshotResolved = null;
 if (transaction.onComplete) {
 // We just set the input snapshot, so this cast should be safe
 var snapshot = new DataSnapshot_1.DataSnapshot(transaction.currentInputSnapshot, new Reference_1.Reference(this, transaction.path), PriorityIndex_1.PRIORITY_INDEX);
 transaction.onComplete(null, false, snapshot);
 }
 }
 else {
 validation_1.validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
 // Mark as run and add to our queue.
 transaction.status = TransactionStatus.RUN;
 var queueNode = this.transactionQueueTree_.subTree(path);
 var nodeQueue = queueNode.getValue() || [];
 nodeQueue.push(transaction);
 queueNode.setValue(nodeQueue);
 // Update visibleData and raise events
 // Note: We intentionally raise events after updating all of our transaction state, since the user could
 // start new transactions from the event callbacks.
 var priorityForNode = void 0;
 if (typeof newVal === 'object' &&
 newVal !== null &&
 util_3.contains(newVal, '.priority')) {
 priorityForNode = util_3.safeGet(newVal, '.priority');
 util_1.assert(validation_1.isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
 'Priority must be a valid string, finite number, server value, or null.');
 }
 else {
 var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
 ChildrenNode_1.ChildrenNode.EMPTY_NODE;
 priorityForNode = currentNode.getPriority().val();
 }
 priorityForNode /** @type {null|number|string} */ = priorityForNode;
 var serverValues = this.generateServerValues();
 var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(newVal, priorityForNode);
 var newNode = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
 transaction.currentOutputSnapshotRaw = newNodeUnresolved;
 transaction.currentOutputSnapshotResolved = newNode;
 transaction.currentWriteId = this.getNextWriteId_();
 var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
 this.eventQueue_.raiseEventsForChangedPath(path, events);
 this.sendReadyTransactions_();
 }
};
/**
 * @param {!Path} path
 * @param {Array.=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
Repo_1.Repo.prototype.getLatestState_ = function (path, excludeSets) {
 return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
 ChildrenNode_1.ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.>=} node transactionQueueTree node to start at.
 * @private
 */
Repo_1.Repo.prototype.sendReadyTransactions_ = function (node) {
 var _this = this;
 if (node === void 0) { node = this.transactionQueueTree_; }
 // Before recursing, make sure any completed transactions are removed.
 if (!node) {
 this.pruneCompletedTransactionsBelowNode_(node);
 }
 if (node.getValue() !== null) {
 var queue = this.buildTransactionQueue_(node);
 util_1.assert(queue.length > 0, 'Sending zero length transaction queue');
 var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
 // If they're all run (and not sent), we can send them. Else, we must wait.
 if (allRun) {
 this.sendTransactionQueue_(node.path(), queue);
 }
 }
 else if (node.hasChildren()) {
 node.forEachChild(function (childNode) {
 _this.sendReadyTransactions_(childNode);
 });
 }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.} queue Queue of transactions under the specified location.
 * @private
 */
Repo_1.Repo.prototype.sendTransactionQueue_ = function (path, queue) {
 var _this = this;
 // Mark transactions as sent and increment retry count!
 var setsToIgnore = queue.map(function (txn) {
 return txn.currentWriteId;
 });
 var latestState = this.getLatestState_(path, setsToIgnore);
 var snapToSend = latestState;
 var latestHash = latestState.hash();
 for (var i = 0; i < queue.length; i++) {
 var txn = queue[i];
 util_1.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
 txn.status = TransactionStatus.SENT;
 txn.retryCount++;
 var relativePath = Path_1.Path.relativePath(path, txn.path);
 // If we've gotten to this point, the output snapshot must be defined.
 snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
 }
 var dataToSend = snapToSend.val(true);
 var pathToSend = path;
 // Send the put.
 this.server_.put(pathToSend.toString(), dataToSend, function (status) {
 _this.log_('transaction put response', {
 path: pathToSend.toString(),
 status: status
 });
 var events = [];
 if (status === 'ok') {
 // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
 // the callback could trigger more transactions or sets.
 var callbacks = [];
 for (var i = 0; i < queue.length; i++) {
 queue[i].status = TransactionStatus.COMPLETED;
 events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
 if (queue[i].onComplete) {
 // We never unset the output snapshot, and given that this transaction is complete, it should be set
 var node = queue[i].currentOutputSnapshotResolved;
 var ref = new Reference_1.Reference(_this, queue[i].path);
 var snapshot = new DataSnapshot_1.DataSnapshot(node, ref, PriorityIndex_1.PRIORITY_INDEX);
 callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
 }
 queue[i].unwatcher();
 }
 // Now remove the completed transactions.
 _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
 // There may be pending transactions that we can now send.
 _this.sendReadyTransactions_();
 _this.eventQueue_.raiseEventsForChangedPath(path, events);
 // Finally, trigger onComplete callbacks.
 for (var i = 0; i < callbacks.length; i++) {
 util_2.exceptionGuard(callbacks[i]);
 }
 }
 else {
 // transactions are no longer sent. Update their status appropriately.
 if (status === 'datastale') {
 for (var i = 0; i < queue.length; i++) {
 if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
 queue[i].status = TransactionStatus.NEEDS_ABORT;
 else
 queue[i].status = TransactionStatus.RUN;
 }
 }
 else {
 util_2.warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
 for (var i = 0; i < queue.length; i++) {
 queue[i].status = TransactionStatus.NEEDS_ABORT;
 queue[i].abortReason = status;
 }
 }
 _this.rerunTransactions_(path);
 }
 }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions. This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
Repo_1.Repo.prototype.rerunTransactions_ = function (changedPath) {
 var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
 var path = rootMostTransactionNode.path();
 var queue = this.buildTransactionQueue_(rootMostTransactionNode);
 this.rerunTransactionQueue_(queue, path);
 return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
Repo_1.Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
 if (queue.length === 0) {
 return; // Nothing to do!
 }
 // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
 // the callback could trigger more transactions or sets.
 var callbacks = [];
 var events = [];
 // Ignore all of the sets we're going to re-run.
 var txnsToRerun = queue.filter(function (q) {
 return q.status === TransactionStatus.RUN;
 });
 var setsToIgnore = txnsToRerun.map(function (q) {
 return q.currentWriteId;
 });
 for (var i = 0; i < queue.length; i++) {
 var transaction = queue[i];
 var relativePath = Path_1.Path.relativePath(path, transaction.path);
 var abortTransaction = false, abortReason = void 0;
 util_1.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
 if (transaction.status === TransactionStatus.NEEDS_ABORT) {
 abortTransaction = true;
 abortReason = transaction.abortReason;
 events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
 }
 else if (transaction.status === TransactionStatus.RUN) {
 if (transaction.retryCount >= Repo_1.Repo.MAX_TRANSACTION_RETRIES_) {
 abortTransaction = true;
 abortReason = 'maxretry';
 events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
 }
 else {
 // This code reruns a transaction
 var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
 transaction.currentInputSnapshot = currentNode;
 var newData = queue[i].update(currentNode.val());
 if (newData !== undefined) {
 validation_1.validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
 var newDataNode = nodeFromJSON_1.nodeFromJSON(newData);
 var hasExplicitPriority = typeof newData === 'object' &&
 newData != null &&
 util_3.contains(newData, '.priority');
 if (!hasExplicitPriority) {
 // Keep the old priority if there wasn't a priority explicitly specified.
 newDataNode = newDataNode.updatePriority(currentNode.getPriority());
 }
 var oldWriteId = transaction.currentWriteId;
 var serverValues = this.generateServerValues();
 var newNodeResolved = ServerValues_1.resolveDeferredValueSnapshot(newDataNode, serverValues);
 transaction.currentOutputSnapshotRaw = newDataNode;
 transaction.currentOutputSnapshotResolved = newNodeResolved;
 transaction.currentWriteId = this.getNextWriteId_();
 // Mutates setsToIgnore in place
 setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
 events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
 events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
 }
 else {
 abortTransaction = true;
 abortReason = 'nodata';
 events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
 }
 }
 }
 this.eventQueue_.raiseEventsForChangedPath(path, events);
 events = [];
 if (abortTransaction) {
 // Abort.
 queue[i].status = TransactionStatus.COMPLETED;
 // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
 // So defer the unwatcher until we're done.
 (function (unwatcher) {
 setTimeout(unwatcher, Math.floor(0));
 })(queue[i].unwatcher);
 if (queue[i].onComplete) {
 if (abortReason === 'nodata') {
 var ref = new Reference_1.Reference(this, queue[i].path);
 // We set this field immediately, so it's safe to cast to an actual snapshot
 var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
 var snapshot = new DataSnapshot_1.DataSnapshot(lastInput, ref, PriorityIndex_1.PRIORITY_INDEX);
 callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
 }
 else {
 callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
 }
 }
 }
 }
 // Clean up completed transactions.
 this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
 // Now fire callbacks, now that we're in a good, known state.
 for (var i = 0; i < callbacks.length; i++) {
 util_2.exceptionGuard(callbacks[i]);
 }
 // Try to send the transaction result to the server.
 this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.>} The rootmost node with a transaction.
 * @private
 */
Repo_1.Repo.prototype.getAncestorTransactionNode_ = function (path) {
 var front;
 // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
 var transactionNode = this.transactionQueueTree_;
 while ((front = path.getFront()) !== null &&
 transactionNode.getValue() === null) {
 transactionNode = transactionNode.subTree(front);
 path = path.popFront();
 }
 return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.>} transactionNode
 * @return {Array.} The generated queue.
 * @private
 */
Repo_1.Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
 // Walk any child transaction queues and aggregate them into a single queue.
 var transactionQueue = [];
 this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
 // Sort them by the order the transactions were created.
 transactionQueue.sort(function (a, b) {
 return a.order - b.order;
 });
 return transactionQueue;
};
/**
 * @param {!Tree.>} node
 * @param {Array.} queue
 * @private
 */
Repo_1.Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
 var _this = this;
 var nodeQueue = node.getValue();
 if (nodeQueue !== null) {
 for (var i = 0; i < nodeQueue.length; i++) {
 queue.push(nodeQueue[i]);
 }
 }
 node.forEachChild(function (child) {
 _this.aggregateTransactionQueuesForNode_(child, queue);
 });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.>} node
 * @private
 */
Repo_1.Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
 var _this = this;
 var queue = node.getValue();
 if (queue) {
 var to = 0;
 for (var from = 0; from < queue.length; from++) {
 if (queue[from].status !== TransactionStatus.COMPLETED) {
 queue[to] = queue[from];
 to++;
 }
 }
 queue.length = to;
 node.setValue(queue.length > 0 ? queue : null);
 }
 node.forEachChild(function (childNode) {
 _this.pruneCompletedTransactionsBelowNode_(childNode);
 });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path. Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
Repo_1.Repo.prototype.abortTransactions_ = function (path) {
 var _this = this;
 var affectedPath = this.getAncestorTransactionNode_(path).path();
 var transactionNode = this.transactionQueueTree_.subTree(path);
 transactionNode.forEachAncestor(function (node) {
 _this.abortTransactionsOnNode_(node);
 });
 this.abortTransactionsOnNode_(transactionNode);
 transactionNode.forEachDescendant(function (node) {
 _this.abortTransactionsOnNode_(node);
 });
 return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.>} node Node to abort transactions for.
 * @private
 */
Repo_1.Repo.prototype.abortTransactionsOnNode_ = function (node) {
 var queue = node.getValue();
 if (queue !== null) {
 // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
 // the callback could trigger more transactions or sets.
 var callbacks = [];
 // Go through queue. Any already-sent transactions must be marked for abort, while the unsent ones
 // can be immediately aborted and removed.
 var events = [];
 var lastSent = -1;
 for (var i = 0; i < queue.length; i++) {
 if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
 // Already marked. No action needed.
 }
 else if (queue[i].status === TransactionStatus.SENT) {
 util_1.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
 lastSent = i;
 // Mark transaction for abort when it comes back.
 queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
 queue[i].abortReason = 'set';
 }
 else {
 util_1.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
 // We can abort it immediately.
 queue[i].unwatcher();
 events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
 if (queue[i].onComplete) {
 var snapshot = null;
 callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
 }
 }
 }
 if (lastSent === -1) {
 // We're not waiting for any sent transactions. We can clear the queue.
 node.setValue(null);
 }
 else {
 // Remove the transactions we aborted.
 queue.length = lastSent + 1;
 }
 // Now fire the callbacks.
 this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
 for (var i = 0; i < callbacks.length; i++) {
 util_2.exceptionGuard(callbacks[i]);
 }
 }
};

//# sourceMappingURL=Repo_transaction.js.map


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(0);
var Path_1 = __webpack_require__(2);
var util_2 = __webpack_require__(0);
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
 function TreeNode() {
 // TODO: Consider making accessors that create children and value lazily or
 // separate Internal / Leaf 'types'.
 this.children = {};
 this.childCount = 0;
 this.value = null;
 }
 return TreeNode;
}());
exports.TreeNode = TreeNode;
/**
 * A light-weight tree, traversable by path. Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
 /**
 * @template T
 * @param {string=} name_ Optional name of the node.
 * @param {Tree=} parent_ Optional parent node.
 * @param {TreeNode=} node_ Optional node to wrap.
 */
 function Tree(name_, parent_, node_) {
 if (name_ === void 0) { name_ = ''; }
 if (parent_ === void 0) { parent_ = null; }
 if (node_ === void 0) { node_ = new TreeNode(); }
 this.name_ = name_;
 this.parent_ = parent_;
 this.node_ = node_;
 }
 /**
 * Returns a sub-Tree for the given path.
 *
 * @param {!(string|Path)} pathObj Path to look up.
 * @return {!Tree.} Tree for path.
 */
 Tree.prototype.subTree = function (pathObj) {
 // TODO: Require pathObj to be Path?
 var path = pathObj instanceof Path_1.Path ? pathObj : new Path_1.Path(pathObj);
 var child = this, next;
 while ((next = path.getFront()) !== null) {
 var childNode = util_2.safeGet(child.node_.children, next) || new TreeNode();
 child = new Tree(next, child, childNode);
 path = path.popFront();
 }
 return child;
 };
 /**
 * Returns the data associated with this tree node.
 *
 * @return {?T} The data or null if no data exists.
 */
 Tree.prototype.getValue = function () {
 return this.node_.value;
 };
 /**
 * Sets data to this tree node.
 *
 * @param {!T} value Value to set.
 */
 Tree.prototype.setValue = function (value) {
 util_1.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
 this.node_.value = value;
 this.updateParents_();
 };
 /**
 * Clears the contents of the tree node (its value and all children).
 */
 Tree.prototype.clear = function () {
 this.node_.value = null;
 this.node_.children = {};
 this.node_.childCount = 0;
 this.updateParents_();
 };
 /**
 * @return {boolean} Whether the tree has any children.
 */
 Tree.prototype.hasChildren = function () {
 return this.node_.childCount > 0;
 };
 /**
 * @return {boolean} Whether the tree is empty (no value or children).
 */
 Tree.prototype.isEmpty = function () {
 return this.getValue() === null && !this.hasChildren();
 };
 /**
 * Calls action for each child of this tree node.
 *
 * @param {function(!Tree.)} action Action to be called for each child.
 */
 Tree.prototype.forEachChild = function (action) {
 var _this = this;
 util_2.forEach(this.node_.children, function (child, childTree) {
 action(new Tree(child, _this, childTree));
 });
 };
 /**
 * Does a depth-first traversal of this node's descendants, calling action for each one.
 *
 * @param {function(!Tree.)} action Action to be called for each child.
 * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
 * false.
 * @param {boolean=} childrenFirst Whether to call action on children before calling it on
 * parent.
 */
 Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
 if (includeSelf && !childrenFirst)
 action(this);
 this.forEachChild(function (child) {
 child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
 });
 if (includeSelf && childrenFirst)
 action(this);
 };
 /**
 * Calls action on each ancestor node.
 *
 * @param {function(!Tree.)} action Action to be called on each parent; return
 * true to abort.
 * @param {boolean=} includeSelf Whether to call action on this node as well.
 * @return {boolean} true if the action callback returned true.
 */
 Tree.prototype.forEachAncestor = function (action, includeSelf) {
 var node = includeSelf ? this : this.parent();
 while (node !== null) {
 if (action(node)) {
 return true;
 }
 node = node.parent();
 }
 return false;
 };
 /**
 * Does a depth-first traversal of this node's descendants. When a descendant with a value
 * is found, action is called on it and traversal does not continue inside the node.
 * Action is *not* called on this node.
 *
 * @param {function(!Tree.)} action Action to be called for each child.
 */
 Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
 this.forEachChild(function (child) {
 if (child.getValue() !== null)
 action(child);
 else
 child.forEachImmediateDescendantWithValue(action);
 });
 };
 /**
 * @return {!Path} The path of this tree node, as a Path.
 */
 Tree.prototype.path = function () {
 return new Path_1.Path(this.parent_ === null
 ? this.name_
 : this.parent_.path() + '/' + this.name_);
 };
 /**
 * @return {string} The name of the tree node.
 */
 Tree.prototype.name = function () {
 return this.name_;
 };
 /**
 * @return {?Tree} The parent tree node, or null if this is the root of the tree.
 */
 Tree.prototype.parent = function () {
 return this.parent_;
 };
 /**
 * Adds or removes this child from its parent based on whether it's empty or not.
 *
 * @private
 */
 Tree.prototype.updateParents_ = function () {
 if (this.parent_ !== null)
 this.parent_.updateChild_(this.name_, this);
 };
 /**
 * Adds or removes the passed child to this tree node, depending on whether it's empty.
 *
 * @param {string} childName The name of the child to update.
 * @param {!Tree.} child The child to update.
 * @private
 */
 Tree.prototype.updateChild_ = function (childName, child) {
 var childEmpty = child.isEmpty();
 var childExists = util_2.contains(this.node_.children, childName);
 if (childEmpty && childExists) {
 delete this.node_.children[childName];
 this.node_.childCount--;
 this.updateParents_();
 }
 else if (!childEmpty && !childExists) {
 this.node_.children[childName] = child.node_;
 this.node_.childCount++;
 this.updateParents_();
 }
 };
 return Tree;
}());
exports.Tree = Tree;

//# sourceMappingURL=Tree.js.map


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var WebSocketConnection_1 = __webpack_require__(54);
var BrowserPollConnection_1 = __webpack_require__(53);
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
exports.forceLongPolling = function () {
 WebSocketConnection_1.WebSocketConnection.forceDisallow();
 BrowserPollConnection_1.BrowserPollConnection.forceAllow();
};
exports.forceWebSockets = function () {
 BrowserPollConnection_1.BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
exports.isWebSocketsAvailable = function () {
 return WebSocketConnection_1.WebSocketConnection['isAvailable']();
};
exports.setSecurityDebugCallback = function (ref, callback) {
 ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
exports.stats = function (ref, showDelta) {
 ref.repo.stats(showDelta);
};
exports.statsIncrementCounter = function (ref, metric) {
 ref.repo.statsIncrementCounter(metric);
};
exports.dataUpdateCount = function (ref) {
 return ref.repo.dataUpdateCount;
};
exports.interceptServerData = function (ref, callback) {
 return ref.repo.interceptServerData_(callback);
};

//# sourceMappingURL=internal.js.map


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var RepoInfo_1 = __webpack_require__(34);
var PersistentConnection_1 = __webpack_require__(50);
var RepoManager_1 = __webpack_require__(26);
var Connection_1 = __webpack_require__(52);
exports.DataConnection = PersistentConnection_1.PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
PersistentConnection_1.PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
 this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
PersistentConnection_1.PersistentConnection.prototype.echo = function (data, onEcho) {
 this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
exports.RealTimeConnection = Connection_1.Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
exports.hijackHash = function (newHash) {
 var oldPut = PersistentConnection_1.PersistentConnection.prototype.put;
 PersistentConnection_1.PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
 if (opt_hash !== undefined) {
 opt_hash = newHash();
 }
 oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
 };
 return function () {
 PersistentConnection_1.PersistentConnection.prototype.put = oldPut;
 };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
exports.ConnectionTarget = RepoInfo_1.RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
exports.queryIdentifier = function (query) {
 return query.queryIdentifier();
};
/**
 * @param {!Query} firebaseRef
 * @return {!Object}
 */
exports.listens = function (firebaseRef) {
 return firebaseRef.repo.persistentConnection_.listens_;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
exports.forceRestClient = function (forceRestClient) {
 RepoManager_1.RepoManager.getInstance().forceRestClient(forceRestClient);
};

//# sourceMappingURL=test_access.js.map


/***/ })
],[78]);
 } catch(error) {
 throw new Error(
 'Cannot instantiate firebase-database.js - ' +
 'be sure to load firebase-app.js first.'
 )
 }


// WEBPACK FOOTER //
// firebase-database.js